/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const sendNewVolunteerMatchRequestEmail = /* GraphQL */ `
  mutation SendNewVolunteerMatchRequestEmail(
    $input: SendNewVolunteerMatchRequestEmailInput!
  ) {
    sendNewVolunteerMatchRequestEmail(input: $input)
  }
`;
export const sendStaffInvitationEmail = /* GraphQL */ `
  mutation SendStaffInvitationEmail($input: SendInvitationEmailInput!) {
    sendStaffInvitationEmail(input: $input)
  }
`;
export const sendFundraisingInvitationEmail = /* GraphQL */ `
  mutation SendFundraisingInvitationEmail($input: SendInvitationEmailInput!) {
    sendFundraisingInvitationEmail(input: $input)
  }
`;
export const sendVolunteerInvitationEmail = /* GraphQL */ `
  mutation SendVolunteerInvitationEmail($input: SendInvitationEmailInput!) {
    sendVolunteerInvitationEmail(input: $input)
  }
`;
export const sendPhoneCallScriptEmail = /* GraphQL */ `
  mutation SendPhoneCallScriptEmail($input: sendPhoneCallScriptEmailInput!) {
    sendPhoneCallScriptEmail(input: $input)
  }
`;
export const getStreamKey = /* GraphQL */ `
  mutation GetStreamKey($input: GetStreamKeyInput!) {
    getStreamKey(input: $input)
  }
`;
export const createVolunteerProfile = /* GraphQL */ `
  mutation CreateVolunteerProfile(
    $input: CreateVolunteerProfileInput!
    $condition: ModelVolunteerProfileConditionInput
  ) {
    createVolunteerProfile(input: $input, condition: $condition) {
      id
      authAccountID
      email
      firstName
      lastName
      gender
      dateOfBirth
      streetAddress
      city
      state
      zip
      website
      enneagram
      enneagramWing
      myersBriggs
      additionalInformation
      availabilityStringified
      latitude
      longitude
      skills {
        items {
          id
          skillID
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          skill {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      causes {
        items {
          id
          causeID
          cause {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const updateVolunteerProfile = /* GraphQL */ `
  mutation UpdateVolunteerProfile(
    $input: UpdateVolunteerProfileInput!
    $condition: ModelVolunteerProfileConditionInput
  ) {
    updateVolunteerProfile(input: $input, condition: $condition) {
      id
      authAccountID
      email
      firstName
      lastName
      gender
      dateOfBirth
      streetAddress
      city
      state
      zip
      website
      enneagram
      enneagramWing
      myersBriggs
      additionalInformation
      availabilityStringified
      latitude
      longitude
      skills {
        items {
          id
          skillID
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          skill {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      causes {
        items {
          id
          causeID
          cause {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const deleteVolunteerProfile = /* GraphQL */ `
  mutation DeleteVolunteerProfile(
    $input: DeleteVolunteerProfileInput!
    $condition: ModelVolunteerProfileConditionInput
  ) {
    deleteVolunteerProfile(input: $input, condition: $condition) {
      id
      authAccountID
      email
      firstName
      lastName
      gender
      dateOfBirth
      streetAddress
      city
      state
      zip
      website
      enneagram
      enneagramWing
      myersBriggs
      additionalInformation
      availabilityStringified
      latitude
      longitude
      skills {
        items {
          id
          skillID
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          skill {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
        }
        nextToken
      }
      causes {
        items {
          id
          causeID
          cause {
            id
            key
            name
            description
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const createOrganizationInvitation = /* GraphQL */ `
  mutation CreateOrganizationInvitation(
    $input: CreateOrganizationInvitationInput!
    $condition: ModelOrganizationInvitationConditionInput
  ) {
    createOrganizationInvitation(input: $input, condition: $condition) {
      id
      code
      email
      name
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganizationInvitation = /* GraphQL */ `
  mutation UpdateOrganizationInvitation(
    $input: UpdateOrganizationInvitationInput!
    $condition: ModelOrganizationInvitationConditionInput
  ) {
    updateOrganizationInvitation(input: $input, condition: $condition) {
      id
      code
      email
      name
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganizationInvitation = /* GraphQL */ `
  mutation DeleteOrganizationInvitation(
    $input: DeleteOrganizationInvitationInput!
    $condition: ModelOrganizationInvitationConditionInput
  ) {
    deleteOrganizationInvitation(input: $input, condition: $condition) {
      id
      code
      email
      name
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const createVolunteerSkill = /* GraphQL */ `
  mutation CreateVolunteerSkill(
    $input: CreateVolunteerSkillInput!
    $condition: ModelVolunteerSkillConditionInput
  ) {
    createVolunteerSkill(input: $input, condition: $condition) {
      id
      skillID
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
      skill {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
    }
  }
`;
export const updateVolunteerSkill = /* GraphQL */ `
  mutation UpdateVolunteerSkill(
    $input: UpdateVolunteerSkillInput!
    $condition: ModelVolunteerSkillConditionInput
  ) {
    updateVolunteerSkill(input: $input, condition: $condition) {
      id
      skillID
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
      skill {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
    }
  }
`;
export const deleteVolunteerSkill = /* GraphQL */ `
  mutation DeleteVolunteerSkill(
    $input: DeleteVolunteerSkillInput!
    $condition: ModelVolunteerSkillConditionInput
  ) {
    deleteVolunteerSkill(input: $input, condition: $condition) {
      id
      skillID
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
      skill {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
    }
  }
`;
export const createCause = /* GraphQL */ `
  mutation CreateCause(
    $input: CreateCauseInput!
    $condition: ModelCauseConditionInput
  ) {
    createCause(input: $input, condition: $condition) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateCause = /* GraphQL */ `
  mutation UpdateCause(
    $input: UpdateCauseInput!
    $condition: ModelCauseConditionInput
  ) {
    updateCause(input: $input, condition: $condition) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteCause = /* GraphQL */ `
  mutation DeleteCause(
    $input: DeleteCauseInput!
    $condition: ModelCauseConditionInput
  ) {
    deleteCause(input: $input, condition: $condition) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const createVolunteerCause = /* GraphQL */ `
  mutation CreateVolunteerCause(
    $input: CreateVolunteerCauseInput!
    $condition: ModelVolunteerCauseConditionInput
  ) {
    createVolunteerCause(input: $input, condition: $condition) {
      id
      causeID
      cause {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateVolunteerCause = /* GraphQL */ `
  mutation UpdateVolunteerCause(
    $input: UpdateVolunteerCauseInput!
    $condition: ModelVolunteerCauseConditionInput
  ) {
    updateVolunteerCause(input: $input, condition: $condition) {
      id
      causeID
      cause {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteVolunteerCause = /* GraphQL */ `
  mutation DeleteVolunteerCause(
    $input: DeleteVolunteerCauseInput!
    $condition: ModelVolunteerCauseConditionInput
  ) {
    deleteVolunteerCause(input: $input, condition: $condition) {
      id
      causeID
      cause {
        id
        key
        name
        description
        createdAt
        updatedAt
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const createOrganizationDetails = /* GraphQL */ `
  mutation CreateOrganizationDetails(
    $input: CreateOrganizationDetailsInput!
    $condition: ModelOrganizationDetailsConditionInput
  ) {
    createOrganizationDetails(input: $input, condition: $condition) {
      id
      organizationID
      missionStatement
      serveStatement
      doStatement
      costToDoStatement
      missionArea
      annualBudget
      currentMonthlyRecurringDonors
      averageMonthlyRecurringDonation
      percentageOfBudgetFromIndividualDonors
      numberOfMajorDonors
      averageOneTimeDonation
      percentageOfBudgetFromGrants
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganizationDetails = /* GraphQL */ `
  mutation UpdateOrganizationDetails(
    $input: UpdateOrganizationDetailsInput!
    $condition: ModelOrganizationDetailsConditionInput
  ) {
    updateOrganizationDetails(input: $input, condition: $condition) {
      id
      organizationID
      missionStatement
      serveStatement
      doStatement
      costToDoStatement
      missionArea
      annualBudget
      currentMonthlyRecurringDonors
      averageMonthlyRecurringDonation
      percentageOfBudgetFromIndividualDonors
      numberOfMajorDonors
      averageOneTimeDonation
      percentageOfBudgetFromGrants
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganizationDetails = /* GraphQL */ `
  mutation DeleteOrganizationDetails(
    $input: DeleteOrganizationDetailsInput!
    $condition: ModelOrganizationDetailsConditionInput
  ) {
    deleteOrganizationDetails(input: $input, condition: $condition) {
      id
      organizationID
      missionStatement
      serveStatement
      doStatement
      costToDoStatement
      missionArea
      annualBudget
      currentMonthlyRecurringDonors
      averageMonthlyRecurringDonation
      percentageOfBudgetFromIndividualDonors
      numberOfMajorDonors
      averageOneTimeDonation
      percentageOfBudgetFromGrants
      createdAt
      updatedAt
    }
  }
`;
export const createProgram = /* GraphQL */ `
  mutation CreateProgram(
    $input: CreateProgramInput!
    $condition: ModelProgramConditionInput
  ) {
    createProgram(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      theWhy
      leadID
      stringifiedCauses
      opportunities {
        items {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      archived
      createdAt
      updatedAt
      lead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateProgram = /* GraphQL */ `
  mutation UpdateProgram(
    $input: UpdateProgramInput!
    $condition: ModelProgramConditionInput
  ) {
    updateProgram(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      theWhy
      leadID
      stringifiedCauses
      opportunities {
        items {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      archived
      createdAt
      updatedAt
      lead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteProgram = /* GraphQL */ `
  mutation DeleteProgram(
    $input: DeleteProgramInput!
    $condition: ModelProgramConditionInput
  ) {
    deleteProgram(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      theWhy
      leadID
      stringifiedCauses
      opportunities {
        items {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      archived
      createdAt
      updatedAt
      lead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createOpportunity = /* GraphQL */ `
  mutation CreateOpportunity(
    $input: CreateOpportunityInput!
    $condition: ModelOpportunityConditionInput
  ) {
    createOpportunity(input: $input, condition: $condition) {
      id
      organizationID
      programID
      program {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityLeadID
      type
      status
      startDate
      endDate
      startRecruitingDate
      headerImage
      title
      descriptionRTE
      theWhy
      expectedImpact
      whatWillHappen
      volunteerGain
      roles {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      stringifiedCauses
      stringifiedCausesJSON
      application {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          screeningCallRequired
          signUpOnly
          requireScreeningCall
          requireBackgroundCheck
          recruitmentDeadlineForVolunteers
          targetNumberOfVolunteerHours
          minimumNumberOfVolunteersRequired
          customApplicationQuestions {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      opportunityLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateOpportunity = /* GraphQL */ `
  mutation UpdateOpportunity(
    $input: UpdateOpportunityInput!
    $condition: ModelOpportunityConditionInput
  ) {
    updateOpportunity(input: $input, condition: $condition) {
      id
      organizationID
      programID
      program {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityLeadID
      type
      status
      startDate
      endDate
      startRecruitingDate
      headerImage
      title
      descriptionRTE
      theWhy
      expectedImpact
      whatWillHappen
      volunteerGain
      roles {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      stringifiedCauses
      stringifiedCausesJSON
      application {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          screeningCallRequired
          signUpOnly
          requireScreeningCall
          requireBackgroundCheck
          recruitmentDeadlineForVolunteers
          targetNumberOfVolunteerHours
          minimumNumberOfVolunteersRequired
          customApplicationQuestions {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      opportunityLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteOpportunity = /* GraphQL */ `
  mutation DeleteOpportunity(
    $input: DeleteOpportunityInput!
    $condition: ModelOpportunityConditionInput
  ) {
    deleteOpportunity(input: $input, condition: $condition) {
      id
      organizationID
      programID
      program {
        id
        organizationID
        name
        description
        theWhy
        leadID
        stringifiedCauses
        opportunities {
          items {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          nextToken
        }
        archived
        createdAt
        updatedAt
        lead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityLeadID
      type
      status
      startDate
      endDate
      startRecruitingDate
      headerImage
      title
      descriptionRTE
      theWhy
      expectedImpact
      whatWillHappen
      volunteerGain
      roles {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      stringifiedCauses
      stringifiedCausesJSON
      application {
        items {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          screeningCallRequired
          signUpOnly
          requireScreeningCall
          requireBackgroundCheck
          recruitmentDeadlineForVolunteers
          targetNumberOfVolunteerHours
          minimumNumberOfVolunteersRequired
          customApplicationQuestions {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      opportunityLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createApplication = /* GraphQL */ `
  mutation CreateApplication(
    $input: CreateApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    createApplication(input: $input, condition: $condition) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      screeningCallRequired
      signUpOnly
      requireScreeningCall
      requireBackgroundCheck
      recruitmentDeadlineForVolunteers
      targetNumberOfVolunteerHours
      minimumNumberOfVolunteersRequired
      customApplicationQuestions {
        items {
          id
          applicationID
          application {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          questionText
          questionType
          required
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateApplication = /* GraphQL */ `
  mutation UpdateApplication(
    $input: UpdateApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    updateApplication(input: $input, condition: $condition) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      screeningCallRequired
      signUpOnly
      requireScreeningCall
      requireBackgroundCheck
      recruitmentDeadlineForVolunteers
      targetNumberOfVolunteerHours
      minimumNumberOfVolunteersRequired
      customApplicationQuestions {
        items {
          id
          applicationID
          application {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          questionText
          questionType
          required
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteApplication = /* GraphQL */ `
  mutation DeleteApplication(
    $input: DeleteApplicationInput!
    $condition: ModelApplicationConditionInput
  ) {
    deleteApplication(input: $input, condition: $condition) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      screeningCallRequired
      signUpOnly
      requireScreeningCall
      requireBackgroundCheck
      recruitmentDeadlineForVolunteers
      targetNumberOfVolunteerHours
      minimumNumberOfVolunteersRequired
      customApplicationQuestions {
        items {
          id
          applicationID
          application {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          questionText
          questionType
          required
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCustomApplicationQuestion = /* GraphQL */ `
  mutation CreateCustomApplicationQuestion(
    $input: CreateCustomApplicationQuestionInput!
    $condition: ModelCustomApplicationQuestionConditionInput
  ) {
    createCustomApplicationQuestion(input: $input, condition: $condition) {
      id
      applicationID
      application {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        screeningCallRequired
        signUpOnly
        requireScreeningCall
        requireBackgroundCheck
        recruitmentDeadlineForVolunteers
        targetNumberOfVolunteerHours
        minimumNumberOfVolunteersRequired
        customApplicationQuestions {
          items {
            id
            applicationID
            questionText
            questionType
            required
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      questionText
      questionType
      required
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomApplicationQuestion = /* GraphQL */ `
  mutation UpdateCustomApplicationQuestion(
    $input: UpdateCustomApplicationQuestionInput!
    $condition: ModelCustomApplicationQuestionConditionInput
  ) {
    updateCustomApplicationQuestion(input: $input, condition: $condition) {
      id
      applicationID
      application {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        screeningCallRequired
        signUpOnly
        requireScreeningCall
        requireBackgroundCheck
        recruitmentDeadlineForVolunteers
        targetNumberOfVolunteerHours
        minimumNumberOfVolunteersRequired
        customApplicationQuestions {
          items {
            id
            applicationID
            questionText
            questionType
            required
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      questionText
      questionType
      required
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomApplicationQuestion = /* GraphQL */ `
  mutation DeleteCustomApplicationQuestion(
    $input: DeleteCustomApplicationQuestionInput!
    $condition: ModelCustomApplicationQuestionConditionInput
  ) {
    deleteCustomApplicationQuestion(input: $input, condition: $condition) {
      id
      applicationID
      application {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        screeningCallRequired
        signUpOnly
        requireScreeningCall
        requireBackgroundCheck
        recruitmentDeadlineForVolunteers
        targetNumberOfVolunteerHours
        minimumNumberOfVolunteersRequired
        customApplicationQuestions {
          items {
            id
            applicationID
            questionText
            questionType
            required
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      questionText
      questionType
      required
      createdAt
      updatedAt
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole(
    $input: CreateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    createRole(input: $input, condition: $condition) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      roleTitle
      opportunityTitle
      live
      roleCoordinatorID
      recurrence
      weeklyRecurrenceDays
      weeklyRecurrenceSameVolunteers
      volunteersPerShift
      differentNumberOfVolunteersPerShift
      volunteerCommitmentMonths
      volunteerCommitmentCanRenew
      roleRequirements
      ageRequirement
      minorsRequireSupervision
      stringifiedCauses
      stringifiedCausesJSON
      stringifiedSkills
      stringifiedSkillsJSON
      stringifiedCertifications
      shifts {
        items {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      roleCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole(
    $input: UpdateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    updateRole(input: $input, condition: $condition) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      roleTitle
      opportunityTitle
      live
      roleCoordinatorID
      recurrence
      weeklyRecurrenceDays
      weeklyRecurrenceSameVolunteers
      volunteersPerShift
      differentNumberOfVolunteersPerShift
      volunteerCommitmentMonths
      volunteerCommitmentCanRenew
      roleRequirements
      ageRequirement
      minorsRequireSupervision
      stringifiedCauses
      stringifiedCausesJSON
      stringifiedSkills
      stringifiedSkillsJSON
      stringifiedCertifications
      shifts {
        items {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      roleCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole(
    $input: DeleteRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    deleteRole(input: $input, condition: $condition) {
      id
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      roleTitle
      opportunityTitle
      live
      roleCoordinatorID
      recurrence
      weeklyRecurrenceDays
      weeklyRecurrenceSameVolunteers
      volunteersPerShift
      differentNumberOfVolunteersPerShift
      volunteerCommitmentMonths
      volunteerCommitmentCanRenew
      roleRequirements
      ageRequirement
      minorsRequireSupervision
      stringifiedCauses
      stringifiedCausesJSON
      stringifiedSkills
      stringifiedSkillsJSON
      stringifiedCertifications
      shifts {
        items {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      roleCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createShift = /* GraphQL */ `
  mutation CreateShift(
    $input: CreateShiftInput!
    $condition: ModelShiftConditionInput
  ) {
    createShift(input: $input, condition: $condition) {
      id
      type
      live
      name
      summary
      startDate
      startTime
      endDate
      endTime
      timezone
      timeFrame
      timeFrameString
      recurrence
      weeklyRecurringDay
      monthlyRecurrenceWeek
      monthlyRecurrenceDay
      flexibleHours
      flexibleTimePeriod
      volunteersNeeded
      volunteerCoordinatorID
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleStringifiedSkills
      roleStringifiedCauses
      locationID
      locationLongitude
      locationLatitude
      locationType
      locationZipEstimate
      locationVariousDescription
      createdAt
      updatedAt
      volunteerCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const updateShift = /* GraphQL */ `
  mutation UpdateShift(
    $input: UpdateShiftInput!
    $condition: ModelShiftConditionInput
  ) {
    updateShift(input: $input, condition: $condition) {
      id
      type
      live
      name
      summary
      startDate
      startTime
      endDate
      endTime
      timezone
      timeFrame
      timeFrameString
      recurrence
      weeklyRecurringDay
      monthlyRecurrenceWeek
      monthlyRecurrenceDay
      flexibleHours
      flexibleTimePeriod
      volunteersNeeded
      volunteerCoordinatorID
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleStringifiedSkills
      roleStringifiedCauses
      locationID
      locationLongitude
      locationLatitude
      locationType
      locationZipEstimate
      locationVariousDescription
      createdAt
      updatedAt
      volunteerCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const deleteShift = /* GraphQL */ `
  mutation DeleteShift(
    $input: DeleteShiftInput!
    $condition: ModelShiftConditionInput
  ) {
    deleteShift(input: $input, condition: $condition) {
      id
      type
      live
      name
      summary
      startDate
      startTime
      endDate
      endTime
      timezone
      timeFrame
      timeFrameString
      recurrence
      weeklyRecurringDay
      monthlyRecurrenceWeek
      monthlyRecurrenceDay
      flexibleHours
      flexibleTimePeriod
      volunteersNeeded
      volunteerCoordinatorID
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleStringifiedSkills
      roleStringifiedCauses
      locationID
      locationLongitude
      locationLatitude
      locationType
      locationZipEstimate
      locationVariousDescription
      createdAt
      updatedAt
      volunteerCoordinator {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const createOpportunityTemplate = /* GraphQL */ `
  mutation CreateOpportunityTemplate(
    $input: CreateOpportunityTemplateInput!
    $condition: ModelOpportunityTemplateConditionInput
  ) {
    createOpportunityTemplate(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateOpportunityTemplate = /* GraphQL */ `
  mutation UpdateOpportunityTemplate(
    $input: UpdateOpportunityTemplateInput!
    $condition: ModelOpportunityTemplateConditionInput
  ) {
    updateOpportunityTemplate(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteOpportunityTemplate = /* GraphQL */ `
  mutation DeleteOpportunityTemplate(
    $input: DeleteOpportunityTemplateInput!
    $condition: ModelOpportunityTemplateConditionInput
  ) {
    deleteOpportunityTemplate(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createRoleTemplate = /* GraphQL */ `
  mutation CreateRoleTemplate(
    $input: CreateRoleTemplateInput!
    $condition: ModelRoleTemplateConditionInput
  ) {
    createRoleTemplate(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateRoleTemplate = /* GraphQL */ `
  mutation UpdateRoleTemplate(
    $input: UpdateRoleTemplateInput!
    $condition: ModelRoleTemplateConditionInput
  ) {
    updateRoleTemplate(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteRoleTemplate = /* GraphQL */ `
  mutation DeleteRoleTemplate(
    $input: DeleteRoleTemplateInput!
    $condition: ModelRoleTemplateConditionInput
  ) {
    deleteRoleTemplate(input: $input, condition: $condition) {
      id
      organizationID
      name
      description
      templateJSON
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createOrganizationGroup = /* GraphQL */ `
  mutation CreateOrganizationGroup(
    $input: CreateOrganizationGroupInput!
    $condition: ModelOrganizationGroupConditionInput
  ) {
    createOrganizationGroup(input: $input, condition: $condition) {
      id
      organizationID
      groupName
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganizationGroup = /* GraphQL */ `
  mutation UpdateOrganizationGroup(
    $input: UpdateOrganizationGroupInput!
    $condition: ModelOrganizationGroupConditionInput
  ) {
    updateOrganizationGroup(input: $input, condition: $condition) {
      id
      organizationID
      groupName
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganizationGroup = /* GraphQL */ `
  mutation DeleteOrganizationGroup(
    $input: DeleteOrganizationGroupInput!
    $condition: ModelOrganizationGroupConditionInput
  ) {
    deleteOrganizationGroup(input: $input, condition: $condition) {
      id
      organizationID
      groupName
      createdAt
      updatedAt
    }
  }
`;
export const createOrganizationVolunteer = /* GraphQL */ `
  mutation CreateOrganizationVolunteer(
    $input: CreateOrganizationVolunteerInput!
    $condition: ModelOrganizationVolunteerConditionInput
  ) {
    createOrganizationVolunteer(input: $input, condition: $condition) {
      id
      organizationID
      volunteerProfileID
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganizationVolunteer = /* GraphQL */ `
  mutation UpdateOrganizationVolunteer(
    $input: UpdateOrganizationVolunteerInput!
    $condition: ModelOrganizationVolunteerConditionInput
  ) {
    updateOrganizationVolunteer(input: $input, condition: $condition) {
      id
      organizationID
      volunteerProfileID
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganizationVolunteer = /* GraphQL */ `
  mutation DeleteOrganizationVolunteer(
    $input: DeleteOrganizationVolunteerInput!
    $condition: ModelOrganizationVolunteerConditionInput
  ) {
    deleteOrganizationVolunteer(input: $input, condition: $condition) {
      id
      organizationID
      volunteerProfileID
      status
      createdAt
      updatedAt
    }
  }
`;
export const createOrganizationGroupVolunteer = /* GraphQL */ `
  mutation CreateOrganizationGroupVolunteer(
    $input: CreateOrganizationGroupVolunteerInput!
    $condition: ModelOrganizationGroupVolunteerConditionInput
  ) {
    createOrganizationGroupVolunteer(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const updateOrganizationGroupVolunteer = /* GraphQL */ `
  mutation UpdateOrganizationGroupVolunteer(
    $input: UpdateOrganizationGroupVolunteerInput!
    $condition: ModelOrganizationGroupVolunteerConditionInput
  ) {
    updateOrganizationGroupVolunteer(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrganizationGroupVolunteer = /* GraphQL */ `
  mutation DeleteOrganizationGroupVolunteer(
    $input: DeleteOrganizationGroupVolunteerInput!
    $condition: ModelOrganizationGroupVolunteerConditionInput
  ) {
    deleteOrganizationGroupVolunteer(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
    }
  }
`;
export const createTimeCommitment = /* GraphQL */ `
  mutation CreateTimeCommitment(
    $input: CreateTimeCommitmentInput!
    $condition: ModelTimeCommitmentConditionInput
  ) {
    createTimeCommitment(input: $input, condition: $condition) {
      id
      amount
      units
      period
      createdAt
      updatedAt
    }
  }
`;
export const updateTimeCommitment = /* GraphQL */ `
  mutation UpdateTimeCommitment(
    $input: UpdateTimeCommitmentInput!
    $condition: ModelTimeCommitmentConditionInput
  ) {
    updateTimeCommitment(input: $input, condition: $condition) {
      id
      amount
      units
      period
      createdAt
      updatedAt
    }
  }
`;
export const deleteTimeCommitment = /* GraphQL */ `
  mutation DeleteTimeCommitment(
    $input: DeleteTimeCommitmentInput!
    $condition: ModelTimeCommitmentConditionInput
  ) {
    deleteTimeCommitment(input: $input, condition: $condition) {
      id
      amount
      units
      period
      createdAt
      updatedAt
    }
  }
`;
export const createVolunteerMatchRequest = /* GraphQL */ `
  mutation CreateVolunteerMatchRequest(
    $input: CreateVolunteerMatchRequestInput!
    $condition: ModelVolunteerMatchRequestConditionInput
  ) {
    createVolunteerMatchRequest(input: $input, condition: $condition) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleRequestedID
      roleRequested {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      volunteerComments
      administrativeNotes
      scheduledCallID
      scheduledCall {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleAssignedID
      roleAssigned {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      assignmentID
      assignment {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      organizationRejectionReason
      volunteerRejectionReason
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateVolunteerMatchRequest = /* GraphQL */ `
  mutation UpdateVolunteerMatchRequest(
    $input: UpdateVolunteerMatchRequestInput!
    $condition: ModelVolunteerMatchRequestConditionInput
  ) {
    updateVolunteerMatchRequest(input: $input, condition: $condition) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleRequestedID
      roleRequested {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      volunteerComments
      administrativeNotes
      scheduledCallID
      scheduledCall {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleAssignedID
      roleAssigned {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      assignmentID
      assignment {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      organizationRejectionReason
      volunteerRejectionReason
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteVolunteerMatchRequest = /* GraphQL */ `
  mutation DeleteVolunteerMatchRequest(
    $input: DeleteVolunteerMatchRequestInput!
    $condition: ModelVolunteerMatchRequestConditionInput
  ) {
    deleteVolunteerMatchRequest(input: $input, condition: $condition) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleRequestedID
      roleRequested {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      volunteerComments
      administrativeNotes
      scheduledCallID
      scheduledCall {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        startTime
        duration
        details
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleAssignedID
      roleAssigned {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      assignmentID
      assignment {
        id
        status
        volunteerMatchRequestID
        volunteerMatchRequest {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          roleRequestedID
          roleRequested {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          organizationID
          volunteerComments
          administrativeNotes
          scheduledCallID
          scheduledCall {
            id
            status
            volunteerProfileID
            organizationID
            startTime
            duration
            details
            createdAt
            updatedAt
          }
          roleAssignedID
          roleAssigned {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          assignmentID
          assignment {
            id
            status
            volunteerMatchRequestID
            roleID
            shiftID
            volunteerProfileID
            opportunityID
            administrativeNotes
            createdAt
            updatedAt
          }
          organizationRejectionReason
          volunteerRejectionReason
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        shiftID
        shift {
          id
          type
          live
          name
          summary
          startDate
          startTime
          endDate
          endTime
          timezone
          timeFrame
          timeFrameString
          recurrence
          weeklyRecurringDay
          monthlyRecurrenceWeek
          monthlyRecurrenceDay
          flexibleHours
          flexibleTimePeriod
          volunteersNeeded
          volunteerCoordinatorID
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          roleStringifiedSkills
          roleStringifiedCauses
          locationID
          locationLongitude
          locationLatitude
          locationType
          locationZipEstimate
          locationVariousDescription
          createdAt
          updatedAt
          volunteerCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        administrativeNotes
        createdAt
        updatedAt
      }
      organizationRejectionReason
      volunteerRejectionReason
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createScheduledCall = /* GraphQL */ `
  mutation CreateScheduledCall(
    $input: CreateScheduledCallInput!
    $condition: ModelScheduledCallConditionInput
  ) {
    createScheduledCall(input: $input, condition: $condition) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      startTime
      duration
      details
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateScheduledCall = /* GraphQL */ `
  mutation UpdateScheduledCall(
    $input: UpdateScheduledCallInput!
    $condition: ModelScheduledCallConditionInput
  ) {
    updateScheduledCall(input: $input, condition: $condition) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      startTime
      duration
      details
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteScheduledCall = /* GraphQL */ `
  mutation DeleteScheduledCall(
    $input: DeleteScheduledCallInput!
    $condition: ModelScheduledCallConditionInput
  ) {
    deleteScheduledCall(input: $input, condition: $condition) {
      id
      status
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      organizationID
      startTime
      duration
      details
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createAssignment = /* GraphQL */ `
  mutation CreateAssignment(
    $input: CreateAssignmentInput!
    $condition: ModelAssignmentConditionInput
  ) {
    createAssignment(input: $input, condition: $condition) {
      id
      status
      volunteerMatchRequestID
      volunteerMatchRequest {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      shiftID
      shift {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      administrativeNotes
      createdAt
      updatedAt
    }
  }
`;
export const updateAssignment = /* GraphQL */ `
  mutation UpdateAssignment(
    $input: UpdateAssignmentInput!
    $condition: ModelAssignmentConditionInput
  ) {
    updateAssignment(input: $input, condition: $condition) {
      id
      status
      volunteerMatchRequestID
      volunteerMatchRequest {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      shiftID
      shift {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      administrativeNotes
      createdAt
      updatedAt
    }
  }
`;
export const deleteAssignment = /* GraphQL */ `
  mutation DeleteAssignment(
    $input: DeleteAssignmentInput!
    $condition: ModelAssignmentConditionInput
  ) {
    deleteAssignment(input: $input, condition: $condition) {
      id
      status
      volunteerMatchRequestID
      volunteerMatchRequest {
        id
        status
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleRequestedID
        roleRequested {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        volunteerComments
        administrativeNotes
        scheduledCallID
        scheduledCall {
          id
          status
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          organizationID
          startTime
          duration
          details
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleAssignedID
        roleAssigned {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        assignmentID
        assignment {
          id
          status
          volunteerMatchRequestID
          volunteerMatchRequest {
            id
            status
            volunteerProfileID
            opportunityID
            roleRequestedID
            organizationID
            volunteerComments
            administrativeNotes
            scheduledCallID
            roleAssignedID
            assignmentID
            organizationRejectionReason
            volunteerRejectionReason
            createdAt
            updatedAt
          }
          roleID
          role {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          shiftID
          shift {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          administrativeNotes
          createdAt
          updatedAt
        }
        organizationRejectionReason
        volunteerRejectionReason
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      roleID
      role {
        id
        opportunityID
        opportunity {
          id
          organizationID
          programID
          program {
            id
            organizationID
            name
            description
            theWhy
            leadID
            stringifiedCauses
            archived
            createdAt
            updatedAt
          }
          opportunityLeadID
          type
          status
          startDate
          endDate
          startRecruitingDate
          headerImage
          title
          descriptionRTE
          theWhy
          expectedImpact
          whatWillHappen
          volunteerGain
          roles {
            nextToken
          }
          stringifiedCauses
          stringifiedCausesJSON
          application {
            nextToken
          }
          createdAt
          updatedAt
          opportunityLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organizationID
        roleTitle
        opportunityTitle
        live
        roleCoordinatorID
        recurrence
        weeklyRecurrenceDays
        weeklyRecurrenceSameVolunteers
        volunteersPerShift
        differentNumberOfVolunteersPerShift
        volunteerCommitmentMonths
        volunteerCommitmentCanRenew
        roleRequirements
        ageRequirement
        minorsRequireSupervision
        stringifiedCauses
        stringifiedCausesJSON
        stringifiedSkills
        stringifiedSkillsJSON
        stringifiedCertifications
        shifts {
          items {
            id
            type
            live
            name
            summary
            startDate
            startTime
            endDate
            endTime
            timezone
            timeFrame
            timeFrameString
            recurrence
            weeklyRecurringDay
            monthlyRecurrenceWeek
            monthlyRecurrenceDay
            flexibleHours
            flexibleTimePeriod
            volunteersNeeded
            volunteerCoordinatorID
            roleID
            roleStringifiedSkills
            roleStringifiedCauses
            locationID
            locationLongitude
            locationLatitude
            locationType
            locationZipEstimate
            locationVariousDescription
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        roleCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      shiftID
      shift {
        id
        type
        live
        name
        summary
        startDate
        startTime
        endDate
        endTime
        timezone
        timeFrame
        timeFrameString
        recurrence
        weeklyRecurringDay
        monthlyRecurrenceWeek
        monthlyRecurrenceDay
        flexibleHours
        flexibleTimePeriod
        volunteersNeeded
        volunteerCoordinatorID
        roleID
        role {
          id
          opportunityID
          opportunity {
            id
            organizationID
            programID
            opportunityLeadID
            type
            status
            startDate
            endDate
            startRecruitingDate
            headerImage
            title
            descriptionRTE
            theWhy
            expectedImpact
            whatWillHappen
            volunteerGain
            stringifiedCauses
            stringifiedCausesJSON
            createdAt
            updatedAt
          }
          organizationID
          roleTitle
          opportunityTitle
          live
          roleCoordinatorID
          recurrence
          weeklyRecurrenceDays
          weeklyRecurrenceSameVolunteers
          volunteersPerShift
          differentNumberOfVolunteersPerShift
          volunteerCommitmentMonths
          volunteerCommitmentCanRenew
          roleRequirements
          ageRequirement
          minorsRequireSupervision
          stringifiedCauses
          stringifiedCausesJSON
          stringifiedSkills
          stringifiedSkillsJSON
          stringifiedCertifications
          shifts {
            nextToken
          }
          createdAt
          updatedAt
          roleCoordinator {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        roleStringifiedSkills
        roleStringifiedCauses
        locationID
        locationLongitude
        locationLatitude
        locationType
        locationZipEstimate
        locationVariousDescription
        createdAt
        updatedAt
        volunteerCoordinator {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      opportunityID
      opportunity {
        id
        organizationID
        programID
        program {
          id
          organizationID
          name
          description
          theWhy
          leadID
          stringifiedCauses
          opportunities {
            nextToken
          }
          archived
          createdAt
          updatedAt
          lead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        opportunityLeadID
        type
        status
        startDate
        endDate
        startRecruitingDate
        headerImage
        title
        descriptionRTE
        theWhy
        expectedImpact
        whatWillHappen
        volunteerGain
        roles {
          items {
            id
            opportunityID
            organizationID
            roleTitle
            opportunityTitle
            live
            roleCoordinatorID
            recurrence
            weeklyRecurrenceDays
            weeklyRecurrenceSameVolunteers
            volunteersPerShift
            differentNumberOfVolunteersPerShift
            volunteerCommitmentMonths
            volunteerCommitmentCanRenew
            roleRequirements
            ageRequirement
            minorsRequireSupervision
            stringifiedCauses
            stringifiedCausesJSON
            stringifiedSkills
            stringifiedSkillsJSON
            stringifiedCertifications
            createdAt
            updatedAt
          }
          nextToken
        }
        stringifiedCauses
        stringifiedCausesJSON
        application {
          items {
            id
            opportunityID
            roleID
            screeningCallRequired
            signUpOnly
            requireScreeningCall
            requireBackgroundCheck
            recruitmentDeadlineForVolunteers
            targetNumberOfVolunteerHours
            minimumNumberOfVolunteersRequired
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        opportunityLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      administrativeNotes
      createdAt
      updatedAt
    }
  }
`;
export const createCheckIn = /* GraphQL */ `
  mutation CreateCheckIn(
    $input: CreateCheckInInput!
    $condition: ModelCheckInConditionInput
  ) {
    createCheckIn(input: $input, condition: $condition) {
      id
      assignmentID
      shiftID
      opportunityID
      timeIn
      timeOut
      checkedInByVolunteerProfileID
      checkedInByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      checkedOutByVolunteerProfileID
      checkedOutByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCheckIn = /* GraphQL */ `
  mutation UpdateCheckIn(
    $input: UpdateCheckInInput!
    $condition: ModelCheckInConditionInput
  ) {
    updateCheckIn(input: $input, condition: $condition) {
      id
      assignmentID
      shiftID
      opportunityID
      timeIn
      timeOut
      checkedInByVolunteerProfileID
      checkedInByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      checkedOutByVolunteerProfileID
      checkedOutByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCheckIn = /* GraphQL */ `
  mutation DeleteCheckIn(
    $input: DeleteCheckInInput!
    $condition: ModelCheckInConditionInput
  ) {
    deleteCheckIn(input: $input, condition: $condition) {
      id
      assignmentID
      shiftID
      opportunityID
      timeIn
      timeOut
      checkedInByVolunteerProfileID
      checkedInByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      checkedOutByVolunteerProfileID
      checkedOutByVolunteer {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const createNotificationSettings = /* GraphQL */ `
  mutation CreateNotificationSettings(
    $input: CreateNotificationSettingsInput!
    $condition: ModelNotificationSettingsConditionInput
  ) {
    createNotificationSettings(input: $input, condition: $condition) {
      id
      communicationsProfileID
      allowPushNotifications
      allowTextMessages
      allowEmail
      preference
      createdAt
      updatedAt
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const updateNotificationSettings = /* GraphQL */ `
  mutation UpdateNotificationSettings(
    $input: UpdateNotificationSettingsInput!
    $condition: ModelNotificationSettingsConditionInput
  ) {
    updateNotificationSettings(input: $input, condition: $condition) {
      id
      communicationsProfileID
      allowPushNotifications
      allowTextMessages
      allowEmail
      preference
      createdAt
      updatedAt
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const deleteNotificationSettings = /* GraphQL */ `
  mutation DeleteNotificationSettings(
    $input: DeleteNotificationSettingsInput!
    $condition: ModelNotificationSettingsConditionInput
  ) {
    deleteNotificationSettings(input: $input, condition: $condition) {
      id
      communicationsProfileID
      allowPushNotifications
      allowTextMessages
      allowEmail
      preference
      createdAt
      updatedAt
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const createLatentOrganizationCode = /* GraphQL */ `
  mutation CreateLatentOrganizationCode(
    $input: CreateLatentOrganizationCodeInput!
    $condition: ModelLatentOrganizationCodeConditionInput
  ) {
    createLatentOrganizationCode(input: $input, condition: $condition) {
      id
      code
      organizationID
      active
      emailRestricted
      emailHostRestriction
      fundraisingCampaignID
      presetFundraisingCampaignAmbassadorStatus
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
    }
  }
`;
export const updateLatentOrganizationCode = /* GraphQL */ `
  mutation UpdateLatentOrganizationCode(
    $input: UpdateLatentOrganizationCodeInput!
    $condition: ModelLatentOrganizationCodeConditionInput
  ) {
    updateLatentOrganizationCode(input: $input, condition: $condition) {
      id
      code
      organizationID
      active
      emailRestricted
      emailHostRestriction
      fundraisingCampaignID
      presetFundraisingCampaignAmbassadorStatus
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
    }
  }
`;
export const deleteLatentOrganizationCode = /* GraphQL */ `
  mutation DeleteLatentOrganizationCode(
    $input: DeleteLatentOrganizationCodeInput!
    $condition: ModelLatentOrganizationCodeConditionInput
  ) {
    deleteLatentOrganizationCode(input: $input, condition: $condition) {
      id
      code
      organizationID
      active
      emailRestricted
      emailHostRestriction
      fundraisingCampaignID
      presetFundraisingCampaignAmbassadorStatus
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
    }
  }
`;
export const createSubscriptionDonationTier = /* GraphQL */ `
  mutation CreateSubscriptionDonationTier(
    $input: CreateSubscriptionDonationTierInput!
    $condition: ModelSubscriptionDonationTierConditionInput
  ) {
    createSubscriptionDonationTier(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      name
      description
      amount
      features
      buttonText
      buttonColor
      default
      highlighted
      highlightedColor
      promoText
      createdAt
      updatedAt
    }
  }
`;
export const updateSubscriptionDonationTier = /* GraphQL */ `
  mutation UpdateSubscriptionDonationTier(
    $input: UpdateSubscriptionDonationTierInput!
    $condition: ModelSubscriptionDonationTierConditionInput
  ) {
    updateSubscriptionDonationTier(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      name
      description
      amount
      features
      buttonText
      buttonColor
      default
      highlighted
      highlightedColor
      promoText
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubscriptionDonationTier = /* GraphQL */ `
  mutation DeleteSubscriptionDonationTier(
    $input: DeleteSubscriptionDonationTierInput!
    $condition: ModelSubscriptionDonationTierConditionInput
  ) {
    deleteSubscriptionDonationTier(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      name
      description
      amount
      features
      buttonText
      buttonColor
      default
      highlighted
      highlightedColor
      promoText
      createdAt
      updatedAt
    }
  }
`;
export const createCampaignConversationFlow = /* GraphQL */ `
  mutation CreateCampaignConversationFlow(
    $input: CreateCampaignConversationFlowInput!
    $condition: ModelCampaignConversationFlowConditionInput
  ) {
    createCampaignConversationFlow(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      name
      description
      default
      active
      actionMessageDefinitions {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      restricted
      useDefaultCta
      customCta
      allowAmbassadorSpecificCrowbarVideos
      generalCrowbarVideoURI
      deleted
      createdAt
      updatedAt
    }
  }
`;
export const updateCampaignConversationFlow = /* GraphQL */ `
  mutation UpdateCampaignConversationFlow(
    $input: UpdateCampaignConversationFlowInput!
    $condition: ModelCampaignConversationFlowConditionInput
  ) {
    updateCampaignConversationFlow(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      name
      description
      default
      active
      actionMessageDefinitions {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      restricted
      useDefaultCta
      customCta
      allowAmbassadorSpecificCrowbarVideos
      generalCrowbarVideoURI
      deleted
      createdAt
      updatedAt
    }
  }
`;
export const deleteCampaignConversationFlow = /* GraphQL */ `
  mutation DeleteCampaignConversationFlow(
    $input: DeleteCampaignConversationFlowInput!
    $condition: ModelCampaignConversationFlowConditionInput
  ) {
    deleteCampaignConversationFlow(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      name
      description
      default
      active
      actionMessageDefinitions {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      restricted
      useDefaultCta
      customCta
      allowAmbassadorSpecificCrowbarVideos
      generalCrowbarVideoURI
      deleted
      createdAt
      updatedAt
    }
  }
`;
export const createActionMessageDefinition = /* GraphQL */ `
  mutation CreateActionMessageDefinition(
    $input: CreateActionMessageDefinitionInput!
    $condition: ModelActionMessageDefinitionConditionInput
  ) {
    createActionMessageDefinition(input: $input, condition: $condition) {
      id
      campaignConversationFlowID
      fundraisingCampaignID
      name
      description
      type
      messageTemplate
      onPositiveResponse
      onNegativeResponse
      otherResponses {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      reminderActionMessageDefinitionID
      reminderActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      reminderDelay
      sendReminderNotification
      reminderNotificationID
      beginningNode
      parentActionMessageDefinitionID
      parentActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      viewType
      createdAt
      updatedAt
    }
  }
`;
export const updateActionMessageDefinition = /* GraphQL */ `
  mutation UpdateActionMessageDefinition(
    $input: UpdateActionMessageDefinitionInput!
    $condition: ModelActionMessageDefinitionConditionInput
  ) {
    updateActionMessageDefinition(input: $input, condition: $condition) {
      id
      campaignConversationFlowID
      fundraisingCampaignID
      name
      description
      type
      messageTemplate
      onPositiveResponse
      onNegativeResponse
      otherResponses {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      reminderActionMessageDefinitionID
      reminderActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      reminderDelay
      sendReminderNotification
      reminderNotificationID
      beginningNode
      parentActionMessageDefinitionID
      parentActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      viewType
      createdAt
      updatedAt
    }
  }
`;
export const deleteActionMessageDefinition = /* GraphQL */ `
  mutation DeleteActionMessageDefinition(
    $input: DeleteActionMessageDefinitionInput!
    $condition: ModelActionMessageDefinitionConditionInput
  ) {
    deleteActionMessageDefinition(input: $input, condition: $condition) {
      id
      campaignConversationFlowID
      fundraisingCampaignID
      name
      description
      type
      messageTemplate
      onPositiveResponse
      onNegativeResponse
      otherResponses {
        items {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        nextToken
      }
      reminderActionMessageDefinitionID
      reminderActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      reminderDelay
      sendReminderNotification
      reminderNotificationID
      beginningNode
      parentActionMessageDefinitionID
      parentActionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      viewType
      createdAt
      updatedAt
    }
  }
`;
export const createActionMessage = /* GraphQL */ `
  mutation CreateActionMessage(
    $input: CreateActionMessageInput!
    $condition: ModelActionMessageConditionInput
  ) {
    createActionMessage(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      fundraisingCampaignAmbassadorContactID
      actionMessageDefinitionID
      actionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      sent
      sentTimestamp
      response
      responseTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const updateActionMessage = /* GraphQL */ `
  mutation UpdateActionMessage(
    $input: UpdateActionMessageInput!
    $condition: ModelActionMessageConditionInput
  ) {
    updateActionMessage(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      fundraisingCampaignAmbassadorContactID
      actionMessageDefinitionID
      actionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      sent
      sentTimestamp
      response
      responseTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const deleteActionMessage = /* GraphQL */ `
  mutation DeleteActionMessage(
    $input: DeleteActionMessageInput!
    $condition: ModelActionMessageConditionInput
  ) {
    deleteActionMessage(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      fundraisingCampaignAmbassadorContactID
      actionMessageDefinitionID
      actionMessageDefinition {
        id
        campaignConversationFlowID
        fundraisingCampaignID
        name
        description
        type
        messageTemplate
        onPositiveResponse
        onNegativeResponse
        otherResponses {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        reminderActionMessageDefinitionID
        reminderActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        reminderDelay
        sendReminderNotification
        reminderNotificationID
        beginningNode
        parentActionMessageDefinitionID
        parentActionMessageDefinition {
          id
          campaignConversationFlowID
          fundraisingCampaignID
          name
          description
          type
          messageTemplate
          onPositiveResponse
          onNegativeResponse
          otherResponses {
            nextToken
          }
          reminderActionMessageDefinitionID
          reminderActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          reminderDelay
          sendReminderNotification
          reminderNotificationID
          beginningNode
          parentActionMessageDefinitionID
          parentActionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          viewType
          createdAt
          updatedAt
        }
        viewType
        createdAt
        updatedAt
      }
      sent
      sentTimestamp
      response
      responseTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      status
      name
      description
      tasks {
        items {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      status
      name
      description
      tasks {
        items {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      status
      name
      description
      tasks {
        items {
          id
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          isTopLevelTask
          name
          overview
          description
          descriptionRTE
          status
          complete
          assignments {
            nextToken
          }
          comments {
            nextToken
          }
          subTasks {
            nextToken
          }
          mediaURI
          attachments {
            nextToken
          }
          createdByID
          actionURL
          dueDate
          blockedBy {
            nextToken
          }
          blocking {
            nextToken
          }
          createdAt
          updatedAt
          createdBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      isTopLevelTask
      name
      overview
      description
      descriptionRTE
      status
      complete
      assignments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          authAccountID
          staffProfileID
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      comments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          comment
          mediaURI
          postedByID
          createdAt
          updatedAt
          postedBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      subTasks {
        items {
          id
          parentTaskID
          parentTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          subTaskID
          subTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      mediaURI
      attachments {
        items {
          id
          taskID
          uploadedByID
          name
          description
          contentType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdByID
      actionURL
      dueDate
      blockedBy {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      blocking {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      createdBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      isTopLevelTask
      name
      overview
      description
      descriptionRTE
      status
      complete
      assignments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          authAccountID
          staffProfileID
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      comments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          comment
          mediaURI
          postedByID
          createdAt
          updatedAt
          postedBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      subTasks {
        items {
          id
          parentTaskID
          parentTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          subTaskID
          subTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      mediaURI
      attachments {
        items {
          id
          taskID
          uploadedByID
          name
          description
          contentType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdByID
      actionURL
      dueDate
      blockedBy {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      blocking {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      createdBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask(
    $input: DeleteTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    deleteTask(input: $input, condition: $condition) {
      id
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      isTopLevelTask
      name
      overview
      description
      descriptionRTE
      status
      complete
      assignments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          authAccountID
          staffProfileID
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      comments {
        items {
          id
          taskID
          task {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          comment
          mediaURI
          postedByID
          createdAt
          updatedAt
          postedBy {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      subTasks {
        items {
          id
          parentTaskID
          parentTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          subTaskID
          subTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      mediaURI
      attachments {
        items {
          id
          taskID
          uploadedByID
          name
          description
          contentType
          createdAt
          updatedAt
        }
        nextToken
      }
      createdByID
      actionURL
      dueDate
      blockedBy {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      blocking {
        items {
          id
          originTaskID
          originTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          blockerTaskID
          blockerTask {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      createdBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const createTaskAttachment = /* GraphQL */ `
  mutation CreateTaskAttachment(
    $input: CreateTaskAttachmentInput!
    $condition: ModelTaskAttachmentConditionInput
  ) {
    createTaskAttachment(input: $input, condition: $condition) {
      id
      taskID
      uploadedByID
      name
      description
      contentType
      createdAt
      updatedAt
    }
  }
`;
export const updateTaskAttachment = /* GraphQL */ `
  mutation UpdateTaskAttachment(
    $input: UpdateTaskAttachmentInput!
    $condition: ModelTaskAttachmentConditionInput
  ) {
    updateTaskAttachment(input: $input, condition: $condition) {
      id
      taskID
      uploadedByID
      name
      description
      contentType
      createdAt
      updatedAt
    }
  }
`;
export const deleteTaskAttachment = /* GraphQL */ `
  mutation DeleteTaskAttachment(
    $input: DeleteTaskAttachmentInput!
    $condition: ModelTaskAttachmentConditionInput
  ) {
    deleteTaskAttachment(input: $input, condition: $condition) {
      id
      taskID
      uploadedByID
      name
      description
      contentType
      createdAt
      updatedAt
    }
  }
`;
export const createTaskBlocker = /* GraphQL */ `
  mutation CreateTaskBlocker(
    $input: CreateTaskBlockerInput!
    $condition: ModelTaskBlockerConditionInput
  ) {
    createTaskBlocker(input: $input, condition: $condition) {
      id
      originTaskID
      originTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      blockerTaskID
      blockerTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const updateTaskBlocker = /* GraphQL */ `
  mutation UpdateTaskBlocker(
    $input: UpdateTaskBlockerInput!
    $condition: ModelTaskBlockerConditionInput
  ) {
    updateTaskBlocker(input: $input, condition: $condition) {
      id
      originTaskID
      originTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      blockerTaskID
      blockerTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const deleteTaskBlocker = /* GraphQL */ `
  mutation DeleteTaskBlocker(
    $input: DeleteTaskBlockerInput!
    $condition: ModelTaskBlockerConditionInput
  ) {
    deleteTaskBlocker(input: $input, condition: $condition) {
      id
      originTaskID
      originTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      blockerTaskID
      blockerTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const createSubTask = /* GraphQL */ `
  mutation CreateSubTask(
    $input: CreateSubTaskInput!
    $condition: ModelSubTaskConditionInput
  ) {
    createSubTask(input: $input, condition: $condition) {
      id
      parentTaskID
      parentTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      subTaskID
      subTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateSubTask = /* GraphQL */ `
  mutation UpdateSubTask(
    $input: UpdateSubTaskInput!
    $condition: ModelSubTaskConditionInput
  ) {
    updateSubTask(input: $input, condition: $condition) {
      id
      parentTaskID
      parentTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      subTaskID
      subTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubTask = /* GraphQL */ `
  mutation DeleteSubTask(
    $input: DeleteSubTaskInput!
    $condition: ModelSubTaskConditionInput
  ) {
    deleteSubTask(input: $input, condition: $condition) {
      id
      parentTaskID
      parentTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      subTaskID
      subTask {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTaskComment = /* GraphQL */ `
  mutation CreateTaskComment(
    $input: CreateTaskCommentInput!
    $condition: ModelTaskCommentConditionInput
  ) {
    createTaskComment(input: $input, condition: $condition) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      comment
      mediaURI
      postedByID
      createdAt
      updatedAt
      postedBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const updateTaskComment = /* GraphQL */ `
  mutation UpdateTaskComment(
    $input: UpdateTaskCommentInput!
    $condition: ModelTaskCommentConditionInput
  ) {
    updateTaskComment(input: $input, condition: $condition) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      comment
      mediaURI
      postedByID
      createdAt
      updatedAt
      postedBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const deleteTaskComment = /* GraphQL */ `
  mutation DeleteTaskComment(
    $input: DeleteTaskCommentInput!
    $condition: ModelTaskCommentConditionInput
  ) {
    deleteTaskComment(input: $input, condition: $condition) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      comment
      mediaURI
      postedByID
      createdAt
      updatedAt
      postedBy {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const createTaskAssignment = /* GraphQL */ `
  mutation CreateTaskAssignment(
    $input: CreateTaskAssignmentInput!
    $condition: ModelTaskAssignmentConditionInput
  ) {
    createTaskAssignment(input: $input, condition: $condition) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      authAccountID
      staffProfileID
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateTaskAssignment = /* GraphQL */ `
  mutation UpdateTaskAssignment(
    $input: UpdateTaskAssignmentInput!
    $condition: ModelTaskAssignmentConditionInput
  ) {
    updateTaskAssignment(input: $input, condition: $condition) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      authAccountID
      staffProfileID
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteTaskAssignment = /* GraphQL */ `
  mutation DeleteTaskAssignment(
    $input: DeleteTaskAssignmentInput!
    $condition: ModelTaskAssignmentConditionInput
  ) {
    deleteTaskAssignment(input: $input, condition: $condition) {
      id
      taskID
      task {
        id
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        isTopLevelTask
        name
        overview
        description
        descriptionRTE
        status
        complete
        assignments {
          items {
            id
            taskID
            authAccountID
            staffProfileID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            taskID
            comment
            mediaURI
            postedByID
            createdAt
            updatedAt
          }
          nextToken
        }
        subTasks {
          items {
            id
            parentTaskID
            subTaskID
            createdAt
            updatedAt
          }
          nextToken
        }
        mediaURI
        attachments {
          items {
            id
            taskID
            uploadedByID
            name
            description
            contentType
            createdAt
            updatedAt
          }
          nextToken
        }
        createdByID
        actionURL
        dueDate
        blockedBy {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        blocking {
          items {
            id
            originTaskID
            blockerTaskID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        createdBy {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      authAccountID
      staffProfileID
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createCognitoAccount = /* GraphQL */ `
  mutation CreateCognitoAccount(
    $input: CreateCognitoAccountInput!
    $condition: ModelCognitoAccountConditionInput
  ) {
    createCognitoAccount(input: $input, condition: $condition) {
      id
      cognitoID
      authAccountID
      createdAt
      updatedAt
      owner
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const updateCognitoAccount = /* GraphQL */ `
  mutation UpdateCognitoAccount(
    $input: UpdateCognitoAccountInput!
    $condition: ModelCognitoAccountConditionInput
  ) {
    updateCognitoAccount(input: $input, condition: $condition) {
      id
      cognitoID
      authAccountID
      createdAt
      updatedAt
      owner
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const deleteCognitoAccount = /* GraphQL */ `
  mutation DeleteCognitoAccount(
    $input: DeleteCognitoAccountInput!
    $condition: ModelCognitoAccountConditionInput
  ) {
    deleteCognitoAccount(input: $input, condition: $condition) {
      id
      cognitoID
      authAccountID
      createdAt
      updatedAt
      owner
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const createAuthAccount = /* GraphQL */ `
  mutation CreateAuthAccount(
    $input: CreateAuthAccountInput!
    $condition: ModelAuthAccountConditionInput
  ) {
    createAuthAccount(input: $input, condition: $condition) {
      id
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      lastSelectedStaffProfileID
      lastSelectedFundraisingProfileID
      communicationsProfileID
      name
      firstName
      lastName
      primaryEmail
      phoneNumber
      dateOfBirth
      gender
      selfDescribedGender
      addressID
      website
      resumeURI
      bio
      profilePictureURI
      headerVideoURI
      headerImageURI
      headerAssetShown
      flourishAdmin
      createdAt
      updatedAt
      cognitoAccounts {
        items {
          id
          cognitoID
          authAccountID
          createdAt
          updatedAt
          owner
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      staffProfile {
        items {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      lastSelectedStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      fundraisingProfiles {
        items {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        nextToken
      }
      lastSelectedFundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const updateAuthAccount = /* GraphQL */ `
  mutation UpdateAuthAccount(
    $input: UpdateAuthAccountInput!
    $condition: ModelAuthAccountConditionInput
  ) {
    updateAuthAccount(input: $input, condition: $condition) {
      id
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      lastSelectedStaffProfileID
      lastSelectedFundraisingProfileID
      communicationsProfileID
      name
      firstName
      lastName
      primaryEmail
      phoneNumber
      dateOfBirth
      gender
      selfDescribedGender
      addressID
      website
      resumeURI
      bio
      profilePictureURI
      headerVideoURI
      headerImageURI
      headerAssetShown
      flourishAdmin
      createdAt
      updatedAt
      cognitoAccounts {
        items {
          id
          cognitoID
          authAccountID
          createdAt
          updatedAt
          owner
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      staffProfile {
        items {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      lastSelectedStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      fundraisingProfiles {
        items {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        nextToken
      }
      lastSelectedFundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const deleteAuthAccount = /* GraphQL */ `
  mutation DeleteAuthAccount(
    $input: DeleteAuthAccountInput!
    $condition: ModelAuthAccountConditionInput
  ) {
    deleteAuthAccount(input: $input, condition: $condition) {
      id
      volunteerProfileID
      volunteerProfile {
        id
        authAccountID
        email
        firstName
        lastName
        gender
        dateOfBirth
        streetAddress
        city
        state
        zip
        website
        enneagram
        enneagramWing
        myersBriggs
        additionalInformation
        availabilityStringified
        latitude
        longitude
        skills {
          items {
            id
            skillID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        causes {
          items {
            id
            causeID
            volunteerProfileID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      lastSelectedStaffProfileID
      lastSelectedFundraisingProfileID
      communicationsProfileID
      name
      firstName
      lastName
      primaryEmail
      phoneNumber
      dateOfBirth
      gender
      selfDescribedGender
      addressID
      website
      resumeURI
      bio
      profilePictureURI
      headerVideoURI
      headerImageURI
      headerAssetShown
      flourishAdmin
      createdAt
      updatedAt
      cognitoAccounts {
        items {
          id
          cognitoID
          authAccountID
          createdAt
          updatedAt
          owner
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      owner
      staffProfile {
        items {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        nextToken
      }
      lastSelectedStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      communicationsProfile {
        id
        authAccountID
        streamJwt
        notificationSettingsID
        notificationSettings {
          id
          communicationsProfileID
          allowPushNotifications
          allowTextMessages
          allowEmail
          preference
          createdAt
          updatedAt
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
        }
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      fundraisingProfiles {
        items {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        nextToken
      }
      lastSelectedFundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const createStaffProfile = /* GraphQL */ `
  mutation CreateStaffProfile(
    $input: CreateStaffProfileInput!
    $condition: ModelStaffProfileConditionInput
  ) {
    createStaffProfile(input: $input, condition: $condition) {
      id
      authAccountID
      organizationID
      role
      name
      nylasAccountID
      nylasCalendarToken
      nylasPrimaryCalendarID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateStaffProfile = /* GraphQL */ `
  mutation UpdateStaffProfile(
    $input: UpdateStaffProfileInput!
    $condition: ModelStaffProfileConditionInput
  ) {
    updateStaffProfile(input: $input, condition: $condition) {
      id
      authAccountID
      organizationID
      role
      name
      nylasAccountID
      nylasCalendarToken
      nylasPrimaryCalendarID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteStaffProfile = /* GraphQL */ `
  mutation DeleteStaffProfile(
    $input: DeleteStaffProfileInput!
    $condition: ModelStaffProfileConditionInput
  ) {
    deleteStaffProfile(input: $input, condition: $condition) {
      id
      authAccountID
      organizationID
      role
      name
      nylasAccountID
      nylasCalendarToken
      nylasPrimaryCalendarID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createCommunicationsProfile = /* GraphQL */ `
  mutation CreateCommunicationsProfile(
    $input: CreateCommunicationsProfileInput!
    $condition: ModelCommunicationsProfileConditionInput
  ) {
    createCommunicationsProfile(input: $input, condition: $condition) {
      id
      authAccountID
      streamJwt
      notificationSettingsID
      notificationSettings {
        id
        communicationsProfileID
        allowPushNotifications
        allowTextMessages
        allowEmail
        preference
        createdAt
        updatedAt
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
    }
  }
`;
export const updateCommunicationsProfile = /* GraphQL */ `
  mutation UpdateCommunicationsProfile(
    $input: UpdateCommunicationsProfileInput!
    $condition: ModelCommunicationsProfileConditionInput
  ) {
    updateCommunicationsProfile(input: $input, condition: $condition) {
      id
      authAccountID
      streamJwt
      notificationSettingsID
      notificationSettings {
        id
        communicationsProfileID
        allowPushNotifications
        allowTextMessages
        allowEmail
        preference
        createdAt
        updatedAt
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
    }
  }
`;
export const deleteCommunicationsProfile = /* GraphQL */ `
  mutation DeleteCommunicationsProfile(
    $input: DeleteCommunicationsProfileInput!
    $condition: ModelCommunicationsProfileConditionInput
  ) {
    deleteCommunicationsProfile(input: $input, condition: $condition) {
      id
      authAccountID
      streamJwt
      notificationSettingsID
      notificationSettings {
        id
        communicationsProfileID
        allowPushNotifications
        allowTextMessages
        allowEmail
        preference
        createdAt
        updatedAt
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
    }
  }
`;
export const createFundraisingProfile = /* GraphQL */ `
  mutation CreateFundraisingProfile(
    $input: CreateFundraisingProfileInput!
    $condition: ModelFundraisingProfileConditionInput
  ) {
    createFundraisingProfile(input: $input, condition: $condition) {
      id
      authAccountID
      organizationID
      email
      firstName
      lastName
      classyMemberID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      campaigns {
        items {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updateFundraisingProfile = /* GraphQL */ `
  mutation UpdateFundraisingProfile(
    $input: UpdateFundraisingProfileInput!
    $condition: ModelFundraisingProfileConditionInput
  ) {
    updateFundraisingProfile(input: $input, condition: $condition) {
      id
      authAccountID
      organizationID
      email
      firstName
      lastName
      classyMemberID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      campaigns {
        items {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteFundraisingProfile = /* GraphQL */ `
  mutation DeleteFundraisingProfile(
    $input: DeleteFundraisingProfileInput!
    $condition: ModelFundraisingProfileConditionInput
  ) {
    deleteFundraisingProfile(input: $input, condition: $condition) {
      id
      authAccountID
      organizationID
      email
      firstName
      lastName
      classyMemberID
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      campaigns {
        items {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createStaffInvitation = /* GraphQL */ `
  mutation CreateStaffInvitation(
    $input: CreateStaffInvitationInput!
    $condition: ModelStaffInvitationConditionInput
  ) {
    createStaffInvitation(input: $input, condition: $condition) {
      id
      code
      type
      email
      domain
      name
      organizationID
      authAccountID
      staffProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateStaffInvitation = /* GraphQL */ `
  mutation UpdateStaffInvitation(
    $input: UpdateStaffInvitationInput!
    $condition: ModelStaffInvitationConditionInput
  ) {
    updateStaffInvitation(input: $input, condition: $condition) {
      id
      code
      type
      email
      domain
      name
      organizationID
      authAccountID
      staffProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteStaffInvitation = /* GraphQL */ `
  mutation DeleteStaffInvitation(
    $input: DeleteStaffInvitationInput!
    $condition: ModelStaffInvitationConditionInput
  ) {
    deleteStaffInvitation(input: $input, condition: $condition) {
      id
      code
      type
      email
      domain
      name
      organizationID
      authAccountID
      staffProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createFundraisingInvitation = /* GraphQL */ `
  mutation CreateFundraisingInvitation(
    $input: CreateFundraisingInvitationInput!
    $condition: ModelFundraisingInvitationConditionInput
  ) {
    createFundraisingInvitation(input: $input, condition: $condition) {
      id
      code
      email
      firstName
      lastName
      domain
      name
      organizationID
      authAccountID
      fundraisingProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateFundraisingInvitation = /* GraphQL */ `
  mutation UpdateFundraisingInvitation(
    $input: UpdateFundraisingInvitationInput!
    $condition: ModelFundraisingInvitationConditionInput
  ) {
    updateFundraisingInvitation(input: $input, condition: $condition) {
      id
      code
      email
      firstName
      lastName
      domain
      name
      organizationID
      authAccountID
      fundraisingProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteFundraisingInvitation = /* GraphQL */ `
  mutation DeleteFundraisingInvitation(
    $input: DeleteFundraisingInvitationInput!
    $condition: ModelFundraisingInvitationConditionInput
  ) {
    deleteFundraisingInvitation(input: $input, condition: $condition) {
      id
      code
      email
      firstName
      lastName
      domain
      name
      organizationID
      authAccountID
      fundraisingProfileID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createVolunteerInvitation = /* GraphQL */ `
  mutation CreateVolunteerInvitation(
    $input: CreateVolunteerInvitationInput!
    $condition: ModelVolunteerInvitationConditionInput
  ) {
    createVolunteerInvitation(input: $input, condition: $condition) {
      id
      code
      email
      name
      firstName
      lastName
      organizationID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const updateVolunteerInvitation = /* GraphQL */ `
  mutation UpdateVolunteerInvitation(
    $input: UpdateVolunteerInvitationInput!
    $condition: ModelVolunteerInvitationConditionInput
  ) {
    updateVolunteerInvitation(input: $input, condition: $condition) {
      id
      code
      email
      name
      firstName
      lastName
      organizationID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const deleteVolunteerInvitation = /* GraphQL */ `
  mutation DeleteVolunteerInvitation(
    $input: DeleteVolunteerInvitationInput!
    $condition: ModelVolunteerInvitationConditionInput
  ) {
    deleteVolunteerInvitation(input: $input, condition: $condition) {
      id
      code
      email
      name
      firstName
      lastName
      organizationID
      used
      usedTimestamp
      invitationSent
      invitationSentTimestamp
      createdAt
      updatedAt
      owner
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
    }
  }
`;
export const createVolunteerWaitlist = /* GraphQL */ `
  mutation CreateVolunteerWaitlist(
    $input: CreateVolunteerWaitlistInput!
    $condition: ModelVolunteerWaitlistConditionInput
  ) {
    createVolunteerWaitlist(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      zipCode
      about
      invited
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateVolunteerWaitlist = /* GraphQL */ `
  mutation UpdateVolunteerWaitlist(
    $input: UpdateVolunteerWaitlistInput!
    $condition: ModelVolunteerWaitlistConditionInput
  ) {
    updateVolunteerWaitlist(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      zipCode
      about
      invited
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteVolunteerWaitlist = /* GraphQL */ `
  mutation DeleteVolunteerWaitlist(
    $input: DeleteVolunteerWaitlistInput!
    $condition: ModelVolunteerWaitlistConditionInput
  ) {
    deleteVolunteerWaitlist(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      zipCode
      about
      invited
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createSkill = /* GraphQL */ `
  mutation CreateSkill(
    $input: CreateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    createSkill(input: $input, condition: $condition) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateSkill = /* GraphQL */ `
  mutation UpdateSkill(
    $input: UpdateSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    updateSkill(input: $input, condition: $condition) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteSkill = /* GraphQL */ `
  mutation DeleteSkill(
    $input: DeleteSkillInput!
    $condition: ModelSkillConditionInput
  ) {
    deleteSkill(input: $input, condition: $condition) {
      id
      key
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $input: CreateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    createOrganization(input: $input, condition: $condition) {
      id
      name
      shortName
      description
      locationID
      website
      phoneNumber
      stripeConnectedAccountID
      stripeConnectedAccountStatus
      headerImageURI
      ambassadorTermOverrideSingular
      ambassadorTermOverridePlural
      streamJwt
      latentSubscription
      primaryColor
      secondaryColor
      designation
      detailsID
      details {
        id
        organizationID
        missionStatement
        serveStatement
        doStatement
        costToDoStatement
        missionArea
        annualBudget
        currentMonthlyRecurringDonors
        averageMonthlyRecurringDonation
        percentageOfBudgetFromIndividualDonors
        numberOfMajorDonors
        averageOneTimeDonation
        percentageOfBudgetFromGrants
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      owner
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $input: UpdateOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    updateOrganization(input: $input, condition: $condition) {
      id
      name
      shortName
      description
      locationID
      website
      phoneNumber
      stripeConnectedAccountID
      stripeConnectedAccountStatus
      headerImageURI
      ambassadorTermOverrideSingular
      ambassadorTermOverridePlural
      streamJwt
      latentSubscription
      primaryColor
      secondaryColor
      designation
      detailsID
      details {
        id
        organizationID
        missionStatement
        serveStatement
        doStatement
        costToDoStatement
        missionArea
        annualBudget
        currentMonthlyRecurringDonors
        averageMonthlyRecurringDonation
        percentageOfBudgetFromIndividualDonors
        numberOfMajorDonors
        averageOneTimeDonation
        percentageOfBudgetFromGrants
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      owner
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $input: DeleteOrganizationInput!
    $condition: ModelOrganizationConditionInput
  ) {
    deleteOrganization(input: $input, condition: $condition) {
      id
      name
      shortName
      description
      locationID
      website
      phoneNumber
      stripeConnectedAccountID
      stripeConnectedAccountStatus
      headerImageURI
      ambassadorTermOverrideSingular
      ambassadorTermOverridePlural
      streamJwt
      latentSubscription
      primaryColor
      secondaryColor
      designation
      detailsID
      details {
        id
        organizationID
        missionStatement
        serveStatement
        doStatement
        costToDoStatement
        missionArea
        annualBudget
        currentMonthlyRecurringDonors
        averageMonthlyRecurringDonation
        percentageOfBudgetFromIndividualDonors
        numberOfMajorDonors
        averageOneTimeDonation
        percentageOfBudgetFromGrants
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      owner
      location {
        id
        type
        name
        details
        addressID
        organizationID
        createdAt
        updatedAt
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      type
      name
      details
      addressID
      organizationID
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      type
      name
      details
      addressID
      organizationID
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      type
      name
      details
      addressID
      organizationID
      createdAt
      updatedAt
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      address {
        id
        streetAddress
        unit
        city
        state
        zip
        zipPlusFour
        longitude
        latitude
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const createAddress = /* GraphQL */ `
  mutation CreateAddress(
    $input: CreateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    createAddress(input: $input, condition: $condition) {
      id
      streetAddress
      unit
      city
      state
      zip
      zipPlusFour
      longitude
      latitude
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateAddress = /* GraphQL */ `
  mutation UpdateAddress(
    $input: UpdateAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    updateAddress(input: $input, condition: $condition) {
      id
      streetAddress
      unit
      city
      state
      zip
      zipPlusFour
      longitude
      latitude
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteAddress = /* GraphQL */ `
  mutation DeleteAddress(
    $input: DeleteAddressInput!
    $condition: ModelAddressConditionInput
  ) {
    deleteAddress(input: $input, condition: $condition) {
      id
      streetAddress
      unit
      city
      state
      zip
      zipPlusFour
      longitude
      latitude
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createFundraisingCampaign = /* GraphQL */ `
  mutation CreateFundraisingCampaign(
    $input: CreateFundraisingCampaignInput!
    $condition: ModelFundraisingCampaignConditionInput
  ) {
    createFundraisingCampaign(input: $input, condition: $condition) {
      id
      type
      organizationID
      staffLeadID
      campaignName
      introVideoURI
      textMessageTemplate
      initialMessageReminderTemplate
      phoneCallScriptTemplate
      followUpMessageTemplate
      followUpYesMessageTemplate
      followUpNoMessageTemplate
      followUpReminderMessageTemplate
      showVideo
      showText
      showCall
      showFollowUp
      active
      publicVideoID
      publicVideoProvider
      campaignStartDate
      campaignStartTime
      campaignTimeZone
      campaignEndDate
      campaignEndTime
      publicCampaignAbout
      publicCampaignIntro
      campaignGoal
      perAmbassadorGoal
      totalAmbassadorsGoal
      perContactDonationGoal
      progressChartType
      ctaURL
      pageLayout
      primaryColor
      secondaryColor
      buttonBackgroundColor
      buttonTextColor
      customHeaderImageUploaded
      customLogoImageUploaded
      headerFont
      bodyFont
      ctaButtonText
      givingCircleBaseAmount
      givingCircleIncrements
      givingCircleAllowCustomAmounts
      ambassadorSpecificVideoUrlEnabled
      ambassadorCanUploadVideoUrl
      ambassadorSpecificCtaUrlEnabled
      ambassadorCanUploadCtaUrl
      crowbarVideoURL
      recruitmentForCampaignID
      classyCampaignID
      classyAutogenerateAmbassadorTeams
      classyDonationPageHostURL
      useClassyCtaURL
      useClassyFundraiserPage
      personalFundraisingCampaignID
      onDemandDiscoveryMeetingEnabled
      onDemandDiscoveryMeetingURL
      onDemandDiscoveryMeetingID
      onDemandDiscoveryMeetingInvitationCode
      CampaignConversationFlows {
        items {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        nextToken
      }
      defaultConversationFlowID
      defaultConversationFlow {
        id
        fundraisingCampaignID
        name
        description
        default
        active
        actionMessageDefinitions {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        restricted
        useDefaultCta
        customCta
        allowAmbassadorSpecificCrowbarVideos
        generalCrowbarVideoURI
        deleted
        createdAt
        updatedAt
      }
      useConversationFlows
      campaignPageID
      ambassadorPageID
      donationPageID
      discoveryPageID
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      subscriptionDonationTiers {
        items {
          id
          fundraisingCampaignID
          name
          description
          amount
          features
          buttonText
          buttonColor
          default
          highlighted
          highlightedColor
          promoText
          createdAt
          updatedAt
        }
        nextToken
      }
      useActionCardView
      createdAt
      updatedAt
      staffLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      recruitmentForCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      personalFundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      campaignPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      ambassadorPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      donationPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      discoveryPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      onDemandDiscoveryMeeting {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const updateFundraisingCampaign = /* GraphQL */ `
  mutation UpdateFundraisingCampaign(
    $input: UpdateFundraisingCampaignInput!
    $condition: ModelFundraisingCampaignConditionInput
  ) {
    updateFundraisingCampaign(input: $input, condition: $condition) {
      id
      type
      organizationID
      staffLeadID
      campaignName
      introVideoURI
      textMessageTemplate
      initialMessageReminderTemplate
      phoneCallScriptTemplate
      followUpMessageTemplate
      followUpYesMessageTemplate
      followUpNoMessageTemplate
      followUpReminderMessageTemplate
      showVideo
      showText
      showCall
      showFollowUp
      active
      publicVideoID
      publicVideoProvider
      campaignStartDate
      campaignStartTime
      campaignTimeZone
      campaignEndDate
      campaignEndTime
      publicCampaignAbout
      publicCampaignIntro
      campaignGoal
      perAmbassadorGoal
      totalAmbassadorsGoal
      perContactDonationGoal
      progressChartType
      ctaURL
      pageLayout
      primaryColor
      secondaryColor
      buttonBackgroundColor
      buttonTextColor
      customHeaderImageUploaded
      customLogoImageUploaded
      headerFont
      bodyFont
      ctaButtonText
      givingCircleBaseAmount
      givingCircleIncrements
      givingCircleAllowCustomAmounts
      ambassadorSpecificVideoUrlEnabled
      ambassadorCanUploadVideoUrl
      ambassadorSpecificCtaUrlEnabled
      ambassadorCanUploadCtaUrl
      crowbarVideoURL
      recruitmentForCampaignID
      classyCampaignID
      classyAutogenerateAmbassadorTeams
      classyDonationPageHostURL
      useClassyCtaURL
      useClassyFundraiserPage
      personalFundraisingCampaignID
      onDemandDiscoveryMeetingEnabled
      onDemandDiscoveryMeetingURL
      onDemandDiscoveryMeetingID
      onDemandDiscoveryMeetingInvitationCode
      CampaignConversationFlows {
        items {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        nextToken
      }
      defaultConversationFlowID
      defaultConversationFlow {
        id
        fundraisingCampaignID
        name
        description
        default
        active
        actionMessageDefinitions {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        restricted
        useDefaultCta
        customCta
        allowAmbassadorSpecificCrowbarVideos
        generalCrowbarVideoURI
        deleted
        createdAt
        updatedAt
      }
      useConversationFlows
      campaignPageID
      ambassadorPageID
      donationPageID
      discoveryPageID
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      subscriptionDonationTiers {
        items {
          id
          fundraisingCampaignID
          name
          description
          amount
          features
          buttonText
          buttonColor
          default
          highlighted
          highlightedColor
          promoText
          createdAt
          updatedAt
        }
        nextToken
      }
      useActionCardView
      createdAt
      updatedAt
      staffLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      recruitmentForCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      personalFundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      campaignPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      ambassadorPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      donationPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      discoveryPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      onDemandDiscoveryMeeting {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const deleteFundraisingCampaign = /* GraphQL */ `
  mutation DeleteFundraisingCampaign(
    $input: DeleteFundraisingCampaignInput!
    $condition: ModelFundraisingCampaignConditionInput
  ) {
    deleteFundraisingCampaign(input: $input, condition: $condition) {
      id
      type
      organizationID
      staffLeadID
      campaignName
      introVideoURI
      textMessageTemplate
      initialMessageReminderTemplate
      phoneCallScriptTemplate
      followUpMessageTemplate
      followUpYesMessageTemplate
      followUpNoMessageTemplate
      followUpReminderMessageTemplate
      showVideo
      showText
      showCall
      showFollowUp
      active
      publicVideoID
      publicVideoProvider
      campaignStartDate
      campaignStartTime
      campaignTimeZone
      campaignEndDate
      campaignEndTime
      publicCampaignAbout
      publicCampaignIntro
      campaignGoal
      perAmbassadorGoal
      totalAmbassadorsGoal
      perContactDonationGoal
      progressChartType
      ctaURL
      pageLayout
      primaryColor
      secondaryColor
      buttonBackgroundColor
      buttonTextColor
      customHeaderImageUploaded
      customLogoImageUploaded
      headerFont
      bodyFont
      ctaButtonText
      givingCircleBaseAmount
      givingCircleIncrements
      givingCircleAllowCustomAmounts
      ambassadorSpecificVideoUrlEnabled
      ambassadorCanUploadVideoUrl
      ambassadorSpecificCtaUrlEnabled
      ambassadorCanUploadCtaUrl
      crowbarVideoURL
      recruitmentForCampaignID
      classyCampaignID
      classyAutogenerateAmbassadorTeams
      classyDonationPageHostURL
      useClassyCtaURL
      useClassyFundraiserPage
      personalFundraisingCampaignID
      onDemandDiscoveryMeetingEnabled
      onDemandDiscoveryMeetingURL
      onDemandDiscoveryMeetingID
      onDemandDiscoveryMeetingInvitationCode
      CampaignConversationFlows {
        items {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        nextToken
      }
      defaultConversationFlowID
      defaultConversationFlow {
        id
        fundraisingCampaignID
        name
        description
        default
        active
        actionMessageDefinitions {
          items {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          nextToken
        }
        restricted
        useDefaultCta
        customCta
        allowAmbassadorSpecificCrowbarVideos
        generalCrowbarVideoURI
        deleted
        createdAt
        updatedAt
      }
      useConversationFlows
      campaignPageID
      ambassadorPageID
      donationPageID
      discoveryPageID
      projectID
      project {
        id
        status
        name
        description
        tasks {
          items {
            id
            projectID
            isTopLevelTask
            name
            overview
            description
            descriptionRTE
            status
            complete
            mediaURI
            createdByID
            actionURL
            dueDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      subscriptionDonationTiers {
        items {
          id
          fundraisingCampaignID
          name
          description
          amount
          features
          buttonText
          buttonColor
          default
          highlighted
          highlightedColor
          promoText
          createdAt
          updatedAt
        }
        nextToken
      }
      useActionCardView
      createdAt
      updatedAt
      staffLead {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      owner
      recruitmentForCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      personalFundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      campaignPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      ambassadorPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      donationPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      discoveryPage {
        id
        name
        description
        type
        fundraisingCampaignID
        campaignDisplayConfigurationID
        pageHtml
        pageJSON
        pageCssJSON
        pageAssetsJSON
        createdAt
        updatedAt
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
        campaignDisplayConfiguration {
          id
          campaignPageID
          primaryColor
          secondaryColor
          gradientLeftColor
          gradientRightColor
          buttonBackgroundColor
          buttonTextColor
          headerFont
          bodyFont
          createdAt
          updatedAt
          owner
        }
      }
      onDemandDiscoveryMeeting {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
    }
  }
`;
export const createCampaignPage = /* GraphQL */ `
  mutation CreateCampaignPage(
    $input: CreateCampaignPageInput!
    $condition: ModelCampaignPageConditionInput
  ) {
    createCampaignPage(input: $input, condition: $condition) {
      id
      name
      description
      type
      fundraisingCampaignID
      campaignDisplayConfigurationID
      pageHtml
      pageJSON
      pageCssJSON
      pageAssetsJSON
      createdAt
      updatedAt
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
      campaignDisplayConfiguration {
        id
        campaignPageID
        primaryColor
        secondaryColor
        gradientLeftColor
        gradientRightColor
        buttonBackgroundColor
        buttonTextColor
        headerFont
        bodyFont
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const updateCampaignPage = /* GraphQL */ `
  mutation UpdateCampaignPage(
    $input: UpdateCampaignPageInput!
    $condition: ModelCampaignPageConditionInput
  ) {
    updateCampaignPage(input: $input, condition: $condition) {
      id
      name
      description
      type
      fundraisingCampaignID
      campaignDisplayConfigurationID
      pageHtml
      pageJSON
      pageCssJSON
      pageAssetsJSON
      createdAt
      updatedAt
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
      campaignDisplayConfiguration {
        id
        campaignPageID
        primaryColor
        secondaryColor
        gradientLeftColor
        gradientRightColor
        buttonBackgroundColor
        buttonTextColor
        headerFont
        bodyFont
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const deleteCampaignPage = /* GraphQL */ `
  mutation DeleteCampaignPage(
    $input: DeleteCampaignPageInput!
    $condition: ModelCampaignPageConditionInput
  ) {
    deleteCampaignPage(input: $input, condition: $condition) {
      id
      name
      description
      type
      fundraisingCampaignID
      campaignDisplayConfigurationID
      pageHtml
      pageJSON
      pageCssJSON
      pageAssetsJSON
      createdAt
      updatedAt
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
      campaignDisplayConfiguration {
        id
        campaignPageID
        primaryColor
        secondaryColor
        gradientLeftColor
        gradientRightColor
        buttonBackgroundColor
        buttonTextColor
        headerFont
        bodyFont
        createdAt
        updatedAt
        owner
      }
    }
  }
`;
export const createCampaignDisplayConfiguration = /* GraphQL */ `
  mutation CreateCampaignDisplayConfiguration(
    $input: CreateCampaignDisplayConfigurationInput!
    $condition: ModelCampaignDisplayConfigurationConditionInput
  ) {
    createCampaignDisplayConfiguration(input: $input, condition: $condition) {
      id
      campaignPageID
      primaryColor
      secondaryColor
      gradientLeftColor
      gradientRightColor
      buttonBackgroundColor
      buttonTextColor
      headerFont
      bodyFont
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateCampaignDisplayConfiguration = /* GraphQL */ `
  mutation UpdateCampaignDisplayConfiguration(
    $input: UpdateCampaignDisplayConfigurationInput!
    $condition: ModelCampaignDisplayConfigurationConditionInput
  ) {
    updateCampaignDisplayConfiguration(input: $input, condition: $condition) {
      id
      campaignPageID
      primaryColor
      secondaryColor
      gradientLeftColor
      gradientRightColor
      buttonBackgroundColor
      buttonTextColor
      headerFont
      bodyFont
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteCampaignDisplayConfiguration = /* GraphQL */ `
  mutation DeleteCampaignDisplayConfiguration(
    $input: DeleteCampaignDisplayConfigurationInput!
    $condition: ModelCampaignDisplayConfigurationConditionInput
  ) {
    deleteCampaignDisplayConfiguration(input: $input, condition: $condition) {
      id
      campaignPageID
      primaryColor
      secondaryColor
      gradientLeftColor
      gradientRightColor
      buttonBackgroundColor
      buttonTextColor
      headerFont
      bodyFont
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createNylasEvent = /* GraphQL */ `
  mutation CreateNylasEvent(
    $input: CreateNylasEventInput!
    $condition: ModelNylasEventConditionInput
  ) {
    createNylasEvent(input: $input, condition: $condition) {
      id
      calendarID
      owner
      fundraisingCampaignDiscoveryCallID
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateNylasEvent = /* GraphQL */ `
  mutation UpdateNylasEvent(
    $input: UpdateNylasEventInput!
    $condition: ModelNylasEventConditionInput
  ) {
    updateNylasEvent(input: $input, condition: $condition) {
      id
      calendarID
      owner
      fundraisingCampaignDiscoveryCallID
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteNylasEvent = /* GraphQL */ `
  mutation DeleteNylasEvent(
    $input: DeleteNylasEventInput!
    $condition: ModelNylasEventConditionInput
  ) {
    deleteNylasEvent(input: $input, condition: $condition) {
      id
      calendarID
      owner
      fundraisingCampaignDiscoveryCallID
      status
      createdAt
      updatedAt
    }
  }
`;
export const createFundraisingCampaignDiscoveryCall = /* GraphQL */ `
  mutation CreateFundraisingCampaignDiscoveryCall(
    $input: CreateFundraisingCampaignDiscoveryCallInput!
    $condition: ModelFundraisingCampaignDiscoveryCallConditionInput
  ) {
    createFundraisingCampaignDiscoveryCall(
      input: $input
      condition: $condition
    ) {
      id
      title
      organizationID
      fundraisingCampaignID
      staffProfileID
      startTimestamp
      endTimestamp
      latentHosted
      invitationURL
      nylasEventID
      virtualMeetingURL
      createdAt
      updatedAt
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const updateFundraisingCampaignDiscoveryCall = /* GraphQL */ `
  mutation UpdateFundraisingCampaignDiscoveryCall(
    $input: UpdateFundraisingCampaignDiscoveryCallInput!
    $condition: ModelFundraisingCampaignDiscoveryCallConditionInput
  ) {
    updateFundraisingCampaignDiscoveryCall(
      input: $input
      condition: $condition
    ) {
      id
      title
      organizationID
      fundraisingCampaignID
      staffProfileID
      startTimestamp
      endTimestamp
      latentHosted
      invitationURL
      nylasEventID
      virtualMeetingURL
      createdAt
      updatedAt
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const deleteFundraisingCampaignDiscoveryCall = /* GraphQL */ `
  mutation DeleteFundraisingCampaignDiscoveryCall(
    $input: DeleteFundraisingCampaignDiscoveryCallInput!
    $condition: ModelFundraisingCampaignDiscoveryCallConditionInput
  ) {
    deleteFundraisingCampaignDiscoveryCall(
      input: $input
      condition: $condition
    ) {
      id
      title
      organizationID
      fundraisingCampaignID
      staffProfileID
      startTimestamp
      endTimestamp
      latentHosted
      invitationURL
      nylasEventID
      virtualMeetingURL
      createdAt
      updatedAt
      staffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      organization {
        id
        name
        shortName
        description
        locationID
        website
        phoneNumber
        stripeConnectedAccountID
        stripeConnectedAccountStatus
        headerImageURI
        ambassadorTermOverrideSingular
        ambassadorTermOverridePlural
        streamJwt
        latentSubscription
        primaryColor
        secondaryColor
        designation
        detailsID
        details {
          id
          organizationID
          missionStatement
          serveStatement
          doStatement
          costToDoStatement
          missionArea
          annualBudget
          currentMonthlyRecurringDonors
          averageMonthlyRecurringDonation
          percentageOfBudgetFromIndividualDonors
          numberOfMajorDonors
          averageOneTimeDonation
          percentageOfBudgetFromGrants
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        owner
        location {
          id
          type
          name
          details
          addressID
          organizationID
          createdAt
          updatedAt
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const createDiscoveryCallParticipant = /* GraphQL */ `
  mutation CreateDiscoveryCallParticipant(
    $input: CreateDiscoveryCallParticipantInput!
    $condition: ModelDiscoveryCallParticipantConditionInput
  ) {
    createDiscoveryCallParticipant(input: $input, condition: $condition) {
      id
      email
      phoneNumber
      firstName
      lastName
      authAccountID
      fundraisingProfileID
      fundraisingCampaignDiscoveryCallID
      fundraisingCampaignID
      invitationSent
      icsString
      status
      recruitedByCampaignAmbassadorID
      confirmed
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      fundraisingCampaignDiscoveryCall {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const updateDiscoveryCallParticipant = /* GraphQL */ `
  mutation UpdateDiscoveryCallParticipant(
    $input: UpdateDiscoveryCallParticipantInput!
    $condition: ModelDiscoveryCallParticipantConditionInput
  ) {
    updateDiscoveryCallParticipant(input: $input, condition: $condition) {
      id
      email
      phoneNumber
      firstName
      lastName
      authAccountID
      fundraisingProfileID
      fundraisingCampaignDiscoveryCallID
      fundraisingCampaignID
      invitationSent
      icsString
      status
      recruitedByCampaignAmbassadorID
      confirmed
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      fundraisingCampaignDiscoveryCall {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const deleteDiscoveryCallParticipant = /* GraphQL */ `
  mutation DeleteDiscoveryCallParticipant(
    $input: DeleteDiscoveryCallParticipantInput!
    $condition: ModelDiscoveryCallParticipantConditionInput
  ) {
    deleteDiscoveryCallParticipant(input: $input, condition: $condition) {
      id
      email
      phoneNumber
      firstName
      lastName
      authAccountID
      fundraisingProfileID
      fundraisingCampaignDiscoveryCallID
      fundraisingCampaignID
      invitationSent
      icsString
      status
      recruitedByCampaignAmbassadorID
      confirmed
      notes
      createdAt
      updatedAt
      authAccount {
        id
        volunteerProfileID
        volunteerProfile {
          id
          authAccountID
          email
          firstName
          lastName
          gender
          dateOfBirth
          streetAddress
          city
          state
          zip
          website
          enneagram
          enneagramWing
          myersBriggs
          additionalInformation
          availabilityStringified
          latitude
          longitude
          skills {
            nextToken
          }
          causes {
            nextToken
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
        }
        lastSelectedStaffProfileID
        lastSelectedFundraisingProfileID
        communicationsProfileID
        name
        firstName
        lastName
        primaryEmail
        phoneNumber
        dateOfBirth
        gender
        selfDescribedGender
        addressID
        website
        resumeURI
        bio
        profilePictureURI
        headerVideoURI
        headerImageURI
        headerAssetShown
        flourishAdmin
        createdAt
        updatedAt
        cognitoAccounts {
          items {
            id
            cognitoID
            authAccountID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        owner
        staffProfile {
          items {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedStaffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        communicationsProfile {
          id
          authAccountID
          streamJwt
          notificationSettingsID
          notificationSettings {
            id
            communicationsProfileID
            allowPushNotifications
            allowTextMessages
            allowEmail
            preference
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
        }
        fundraisingProfiles {
          items {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
        lastSelectedFundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        address {
          id
          streetAddress
          unit
          city
          state
          zip
          zipPlusFour
          longitude
          latitude
          createdAt
          updatedAt
          owner
        }
      }
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      fundraisingCampaignDiscoveryCall {
        id
        title
        organizationID
        fundraisingCampaignID
        staffProfileID
        startTimestamp
        endTimestamp
        latentHosted
        invitationURL
        nylasEventID
        virtualMeetingURL
        createdAt
        updatedAt
        staffProfile {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        owner
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
    }
  }
`;
export const createFundraisingCampaignAmbassador = /* GraphQL */ `
  mutation CreateFundraisingCampaignAmbassador(
    $input: CreateFundraisingCampaignAmbassadorInput!
    $condition: ModelFundraisingCampaignAmbassadorConditionInput
  ) {
    createFundraisingCampaignAmbassador(input: $input, condition: $condition) {
      id
      status
      commitment
      fundraisingProfileID
      fundraisingCampaignID
      discoveryCallParticipantID
      fundsRaised
      initialTransactionID
      initialTransactionAmount
      ambassadorSpecificCtaUrl
      ambassadorSpecificVideoUrl
      recruitedByCampaignAmbassadorID
      classyTeamID
      classySupporterID
      classyFundraiserPageID
      notificationsEnabled
      createdAt
      updatedAt
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaignAmbassadorContacts {
        items {
          id
          deviceContactID
          fundraisingProfileID
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          sentText
          sentTextTimestamp
          sentInitialTextReminder
          sentInitialTextReminderTimestamp
          sentPhoneCallScript
          sentPhoneCallScriptTimestamp
          called
          calledTimestamp
          sentFollowUp
          sentFollowUpTimestamp
          followUpResponse
          sentReminder
          sentReminderTimestamp
          isDonating
          donationAmount
          discoveryCallParticipantID
          transactionID
          isActive
          notes
          birthday
          hasTakenAction
          hasTakenActionTimestamp
          occupation
          selectedPhoneNumberArrayIndex
          actionMessages {
            nextToken
          }
          createdAt
          updatedAt
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateFundraisingCampaignAmbassador = /* GraphQL */ `
  mutation UpdateFundraisingCampaignAmbassador(
    $input: UpdateFundraisingCampaignAmbassadorInput!
    $condition: ModelFundraisingCampaignAmbassadorConditionInput
  ) {
    updateFundraisingCampaignAmbassador(input: $input, condition: $condition) {
      id
      status
      commitment
      fundraisingProfileID
      fundraisingCampaignID
      discoveryCallParticipantID
      fundsRaised
      initialTransactionID
      initialTransactionAmount
      ambassadorSpecificCtaUrl
      ambassadorSpecificVideoUrl
      recruitedByCampaignAmbassadorID
      classyTeamID
      classySupporterID
      classyFundraiserPageID
      notificationsEnabled
      createdAt
      updatedAt
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaignAmbassadorContacts {
        items {
          id
          deviceContactID
          fundraisingProfileID
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          sentText
          sentTextTimestamp
          sentInitialTextReminder
          sentInitialTextReminderTimestamp
          sentPhoneCallScript
          sentPhoneCallScriptTimestamp
          called
          calledTimestamp
          sentFollowUp
          sentFollowUpTimestamp
          followUpResponse
          sentReminder
          sentReminderTimestamp
          isDonating
          donationAmount
          discoveryCallParticipantID
          transactionID
          isActive
          notes
          birthday
          hasTakenAction
          hasTakenActionTimestamp
          occupation
          selectedPhoneNumberArrayIndex
          actionMessages {
            nextToken
          }
          createdAt
          updatedAt
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteFundraisingCampaignAmbassador = /* GraphQL */ `
  mutation DeleteFundraisingCampaignAmbassador(
    $input: DeleteFundraisingCampaignAmbassadorInput!
    $condition: ModelFundraisingCampaignAmbassadorConditionInput
  ) {
    deleteFundraisingCampaignAmbassador(input: $input, condition: $condition) {
      id
      status
      commitment
      fundraisingProfileID
      fundraisingCampaignID
      discoveryCallParticipantID
      fundsRaised
      initialTransactionID
      initialTransactionAmount
      ambassadorSpecificCtaUrl
      ambassadorSpecificVideoUrl
      recruitedByCampaignAmbassadorID
      classyTeamID
      classySupporterID
      classyFundraiserPageID
      notificationsEnabled
      createdAt
      updatedAt
      fundraisingProfile {
        id
        authAccountID
        organizationID
        email
        firstName
        lastName
        classyMemberID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        campaigns {
          items {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      owner
      recruitedByCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      fundraisingCampaignAmbassadorContacts {
        items {
          id
          deviceContactID
          fundraisingProfileID
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          sentText
          sentTextTimestamp
          sentInitialTextReminder
          sentInitialTextReminderTimestamp
          sentPhoneCallScript
          sentPhoneCallScriptTimestamp
          called
          calledTimestamp
          sentFollowUp
          sentFollowUpTimestamp
          followUpResponse
          sentReminder
          sentReminderTimestamp
          isDonating
          donationAmount
          discoveryCallParticipantID
          transactionID
          isActive
          notes
          birthday
          hasTakenAction
          hasTakenActionTimestamp
          occupation
          selectedPhoneNumberArrayIndex
          actionMessages {
            nextToken
          }
          createdAt
          updatedAt
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          owner
        }
        nextToken
      }
    }
  }
`;
export const createFundraisingCampaignAmbassadorContact = /* GraphQL */ `
  mutation CreateFundraisingCampaignAmbassadorContact(
    $input: CreateFundraisingCampaignAmbassadorContactInput!
    $condition: ModelFundraisingCampaignAmbassadorContactConditionInput
  ) {
    createFundraisingCampaignAmbassadorContact(
      input: $input
      condition: $condition
    ) {
      id
      deviceContactID
      fundraisingProfileID
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      sentText
      sentTextTimestamp
      sentInitialTextReminder
      sentInitialTextReminderTimestamp
      sentPhoneCallScript
      sentPhoneCallScriptTimestamp
      called
      calledTimestamp
      sentFollowUp
      sentFollowUpTimestamp
      followUpResponse
      sentReminder
      sentReminderTimestamp
      isDonating
      donationAmount
      discoveryCallParticipantID
      transactionID
      isActive
      notes
      birthday
      hasTakenAction
      hasTakenActionTimestamp
      occupation
      selectedPhoneNumberArrayIndex
      actionMessages {
        items {
          id
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          fundraisingCampaignAmbassadorContactID
          actionMessageDefinitionID
          actionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          sent
          sentTimestamp
          response
          responseTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      fundraisingCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const updateFundraisingCampaignAmbassadorContact = /* GraphQL */ `
  mutation UpdateFundraisingCampaignAmbassadorContact(
    $input: UpdateFundraisingCampaignAmbassadorContactInput!
    $condition: ModelFundraisingCampaignAmbassadorContactConditionInput
  ) {
    updateFundraisingCampaignAmbassadorContact(
      input: $input
      condition: $condition
    ) {
      id
      deviceContactID
      fundraisingProfileID
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      sentText
      sentTextTimestamp
      sentInitialTextReminder
      sentInitialTextReminderTimestamp
      sentPhoneCallScript
      sentPhoneCallScriptTimestamp
      called
      calledTimestamp
      sentFollowUp
      sentFollowUpTimestamp
      followUpResponse
      sentReminder
      sentReminderTimestamp
      isDonating
      donationAmount
      discoveryCallParticipantID
      transactionID
      isActive
      notes
      birthday
      hasTakenAction
      hasTakenActionTimestamp
      occupation
      selectedPhoneNumberArrayIndex
      actionMessages {
        items {
          id
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          fundraisingCampaignAmbassadorContactID
          actionMessageDefinitionID
          actionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          sent
          sentTimestamp
          response
          responseTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      fundraisingCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const deleteFundraisingCampaignAmbassadorContact = /* GraphQL */ `
  mutation DeleteFundraisingCampaignAmbassadorContact(
    $input: DeleteFundraisingCampaignAmbassadorContactInput!
    $condition: ModelFundraisingCampaignAmbassadorContactConditionInput
  ) {
    deleteFundraisingCampaignAmbassadorContact(
      input: $input
      condition: $condition
    ) {
      id
      deviceContactID
      fundraisingProfileID
      fundraisingCampaignID
      fundraisingCampaignAmbassadorID
      sentText
      sentTextTimestamp
      sentInitialTextReminder
      sentInitialTextReminderTimestamp
      sentPhoneCallScript
      sentPhoneCallScriptTimestamp
      called
      calledTimestamp
      sentFollowUp
      sentFollowUpTimestamp
      followUpResponse
      sentReminder
      sentReminderTimestamp
      isDonating
      donationAmount
      discoveryCallParticipantID
      transactionID
      isActive
      notes
      birthday
      hasTakenAction
      hasTakenActionTimestamp
      occupation
      selectedPhoneNumberArrayIndex
      actionMessages {
        items {
          id
          fundraisingCampaignID
          fundraisingCampaignAmbassadorID
          fundraisingCampaignAmbassadorContactID
          actionMessageDefinitionID
          actionMessageDefinition {
            id
            campaignConversationFlowID
            fundraisingCampaignID
            name
            description
            type
            messageTemplate
            onPositiveResponse
            onNegativeResponse
            reminderActionMessageDefinitionID
            reminderDelay
            sendReminderNotification
            reminderNotificationID
            beginningNode
            parentActionMessageDefinitionID
            viewType
            createdAt
            updatedAt
          }
          sent
          sentTimestamp
          response
          responseTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      discoveryCallParticipant {
        id
        email
        phoneNumber
        firstName
        lastName
        authAccountID
        fundraisingProfileID
        fundraisingCampaignDiscoveryCallID
        fundraisingCampaignID
        invitationSent
        icsString
        status
        recruitedByCampaignAmbassadorID
        confirmed
        notes
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        fundraisingCampaignDiscoveryCall {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
      }
      fundraisingCampaignAmbassador {
        id
        status
        commitment
        fundraisingProfileID
        fundraisingCampaignID
        discoveryCallParticipantID
        fundsRaised
        initialTransactionID
        initialTransactionAmount
        ambassadorSpecificCtaUrl
        ambassadorSpecificVideoUrl
        recruitedByCampaignAmbassadorID
        classyTeamID
        classySupporterID
        classyFundraiserPageID
        notificationsEnabled
        createdAt
        updatedAt
        fundraisingProfile {
          id
          authAccountID
          organizationID
          email
          firstName
          lastName
          classyMemberID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          campaigns {
            nextToken
          }
        }
        fundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        discoveryCallParticipant {
          id
          email
          phoneNumber
          firstName
          lastName
          authAccountID
          fundraisingProfileID
          fundraisingCampaignDiscoveryCallID
          fundraisingCampaignID
          invitationSent
          icsString
          status
          recruitedByCampaignAmbassadorID
          confirmed
          notes
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignDiscoveryCall {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitedByCampaignAmbassador {
          id
          status
          commitment
          fundraisingProfileID
          fundraisingCampaignID
          discoveryCallParticipantID
          fundsRaised
          initialTransactionID
          initialTransactionAmount
          ambassadorSpecificCtaUrl
          ambassadorSpecificVideoUrl
          recruitedByCampaignAmbassadorID
          classyTeamID
          classySupporterID
          classyFundraiserPageID
          notificationsEnabled
          createdAt
          updatedAt
          fundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          discoveryCallParticipant {
            id
            email
            phoneNumber
            firstName
            lastName
            authAccountID
            fundraisingProfileID
            fundraisingCampaignDiscoveryCallID
            fundraisingCampaignID
            invitationSent
            icsString
            status
            recruitedByCampaignAmbassadorID
            confirmed
            notes
            createdAt
            updatedAt
            owner
          }
          owner
          recruitedByCampaignAmbassador {
            id
            status
            commitment
            fundraisingProfileID
            fundraisingCampaignID
            discoveryCallParticipantID
            fundsRaised
            initialTransactionID
            initialTransactionAmount
            ambassadorSpecificCtaUrl
            ambassadorSpecificVideoUrl
            recruitedByCampaignAmbassadorID
            classyTeamID
            classySupporterID
            classyFundraiserPageID
            notificationsEnabled
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaignAmbassadorContacts {
            nextToken
          }
        }
        fundraisingCampaignAmbassadorContacts {
          items {
            id
            deviceContactID
            fundraisingProfileID
            fundraisingCampaignID
            fundraisingCampaignAmbassadorID
            sentText
            sentTextTimestamp
            sentInitialTextReminder
            sentInitialTextReminderTimestamp
            sentPhoneCallScript
            sentPhoneCallScriptTimestamp
            called
            calledTimestamp
            sentFollowUp
            sentFollowUpTimestamp
            followUpResponse
            sentReminder
            sentReminderTimestamp
            isDonating
            donationAmount
            discoveryCallParticipantID
            transactionID
            isActive
            notes
            birthday
            hasTakenAction
            hasTakenActionTimestamp
            occupation
            selectedPhoneNumberArrayIndex
            createdAt
            updatedAt
            owner
          }
          nextToken
        }
      }
      owner
    }
  }
`;
export const createFundraisingCampaignUpdate = /* GraphQL */ `
  mutation CreateFundraisingCampaignUpdate(
    $input: CreateFundraisingCampaignUpdateInput!
    $condition: ModelFundraisingCampaignUpdateConditionInput
  ) {
    createFundraisingCampaignUpdate(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      public
      message
      assetsUploaded
      updateURL
      createdByStaffProfileID
      live
      liveTimestamp
      createdAt
      updatedAt
      createdByStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const updateFundraisingCampaignUpdate = /* GraphQL */ `
  mutation UpdateFundraisingCampaignUpdate(
    $input: UpdateFundraisingCampaignUpdateInput!
    $condition: ModelFundraisingCampaignUpdateConditionInput
  ) {
    updateFundraisingCampaignUpdate(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      public
      message
      assetsUploaded
      updateURL
      createdByStaffProfileID
      live
      liveTimestamp
      createdAt
      updatedAt
      createdByStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
export const deleteFundraisingCampaignUpdate = /* GraphQL */ `
  mutation DeleteFundraisingCampaignUpdate(
    $input: DeleteFundraisingCampaignUpdateInput!
    $condition: ModelFundraisingCampaignUpdateConditionInput
  ) {
    deleteFundraisingCampaignUpdate(input: $input, condition: $condition) {
      id
      fundraisingCampaignID
      public
      message
      assetsUploaded
      updateURL
      createdByStaffProfileID
      live
      liveTimestamp
      createdAt
      updatedAt
      createdByStaffProfile {
        id
        authAccountID
        organizationID
        role
        name
        nylasAccountID
        nylasCalendarToken
        nylasPrimaryCalendarID
        createdAt
        updatedAt
        authAccount {
          id
          volunteerProfileID
          volunteerProfile {
            id
            authAccountID
            email
            firstName
            lastName
            gender
            dateOfBirth
            streetAddress
            city
            state
            zip
            website
            enneagram
            enneagramWing
            myersBriggs
            additionalInformation
            availabilityStringified
            latitude
            longitude
            createdAt
            updatedAt
          }
          lastSelectedStaffProfileID
          lastSelectedFundraisingProfileID
          communicationsProfileID
          name
          firstName
          lastName
          primaryEmail
          phoneNumber
          dateOfBirth
          gender
          selfDescribedGender
          addressID
          website
          resumeURI
          bio
          profilePictureURI
          headerVideoURI
          headerImageURI
          headerAssetShown
          flourishAdmin
          createdAt
          updatedAt
          cognitoAccounts {
            nextToken
          }
          owner
          staffProfile {
            nextToken
          }
          lastSelectedStaffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          communicationsProfile {
            id
            authAccountID
            streamJwt
            notificationSettingsID
            createdAt
            updatedAt
            owner
          }
          fundraisingProfiles {
            nextToken
          }
          lastSelectedFundraisingProfile {
            id
            authAccountID
            organizationID
            email
            firstName
            lastName
            classyMemberID
            createdAt
            updatedAt
            owner
          }
          address {
            id
            streetAddress
            unit
            city
            state
            zip
            zipPlusFour
            longitude
            latitude
            createdAt
            updatedAt
            owner
          }
        }
        owner
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
      }
      fundraisingCampaign {
        id
        type
        organizationID
        staffLeadID
        campaignName
        introVideoURI
        textMessageTemplate
        initialMessageReminderTemplate
        phoneCallScriptTemplate
        followUpMessageTemplate
        followUpYesMessageTemplate
        followUpNoMessageTemplate
        followUpReminderMessageTemplate
        showVideo
        showText
        showCall
        showFollowUp
        active
        publicVideoID
        publicVideoProvider
        campaignStartDate
        campaignStartTime
        campaignTimeZone
        campaignEndDate
        campaignEndTime
        publicCampaignAbout
        publicCampaignIntro
        campaignGoal
        perAmbassadorGoal
        totalAmbassadorsGoal
        perContactDonationGoal
        progressChartType
        ctaURL
        pageLayout
        primaryColor
        secondaryColor
        buttonBackgroundColor
        buttonTextColor
        customHeaderImageUploaded
        customLogoImageUploaded
        headerFont
        bodyFont
        ctaButtonText
        givingCircleBaseAmount
        givingCircleIncrements
        givingCircleAllowCustomAmounts
        ambassadorSpecificVideoUrlEnabled
        ambassadorCanUploadVideoUrl
        ambassadorSpecificCtaUrlEnabled
        ambassadorCanUploadCtaUrl
        crowbarVideoURL
        recruitmentForCampaignID
        classyCampaignID
        classyAutogenerateAmbassadorTeams
        classyDonationPageHostURL
        useClassyCtaURL
        useClassyFundraiserPage
        personalFundraisingCampaignID
        onDemandDiscoveryMeetingEnabled
        onDemandDiscoveryMeetingURL
        onDemandDiscoveryMeetingID
        onDemandDiscoveryMeetingInvitationCode
        CampaignConversationFlows {
          items {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          nextToken
        }
        defaultConversationFlowID
        defaultConversationFlow {
          id
          fundraisingCampaignID
          name
          description
          default
          active
          actionMessageDefinitions {
            nextToken
          }
          restricted
          useDefaultCta
          customCta
          allowAmbassadorSpecificCrowbarVideos
          generalCrowbarVideoURI
          deleted
          createdAt
          updatedAt
        }
        useConversationFlows
        campaignPageID
        ambassadorPageID
        donationPageID
        discoveryPageID
        projectID
        project {
          id
          status
          name
          description
          tasks {
            nextToken
          }
          createdAt
          updatedAt
        }
        subscriptionDonationTiers {
          items {
            id
            fundraisingCampaignID
            name
            description
            amount
            features
            buttonText
            buttonColor
            default
            highlighted
            highlightedColor
            promoText
            createdAt
            updatedAt
          }
          nextToken
        }
        useActionCardView
        createdAt
        updatedAt
        staffLead {
          id
          authAccountID
          organizationID
          role
          name
          nylasAccountID
          nylasCalendarToken
          nylasPrimaryCalendarID
          createdAt
          updatedAt
          authAccount {
            id
            volunteerProfileID
            lastSelectedStaffProfileID
            lastSelectedFundraisingProfileID
            communicationsProfileID
            name
            firstName
            lastName
            primaryEmail
            phoneNumber
            dateOfBirth
            gender
            selfDescribedGender
            addressID
            website
            resumeURI
            bio
            profilePictureURI
            headerVideoURI
            headerImageURI
            headerAssetShown
            flourishAdmin
            createdAt
            updatedAt
            owner
          }
          owner
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
        }
        organization {
          id
          name
          shortName
          description
          locationID
          website
          phoneNumber
          stripeConnectedAccountID
          stripeConnectedAccountStatus
          headerImageURI
          ambassadorTermOverrideSingular
          ambassadorTermOverridePlural
          streamJwt
          latentSubscription
          primaryColor
          secondaryColor
          designation
          detailsID
          details {
            id
            organizationID
            missionStatement
            serveStatement
            doStatement
            costToDoStatement
            missionArea
            annualBudget
            currentMonthlyRecurringDonors
            averageMonthlyRecurringDonation
            percentageOfBudgetFromIndividualDonors
            numberOfMajorDonors
            averageOneTimeDonation
            percentageOfBudgetFromGrants
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
          owner
          location {
            id
            type
            name
            details
            addressID
            organizationID
            createdAt
            updatedAt
            owner
          }
        }
        owner
        recruitmentForCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        personalFundraisingCampaign {
          id
          type
          organizationID
          staffLeadID
          campaignName
          introVideoURI
          textMessageTemplate
          initialMessageReminderTemplate
          phoneCallScriptTemplate
          followUpMessageTemplate
          followUpYesMessageTemplate
          followUpNoMessageTemplate
          followUpReminderMessageTemplate
          showVideo
          showText
          showCall
          showFollowUp
          active
          publicVideoID
          publicVideoProvider
          campaignStartDate
          campaignStartTime
          campaignTimeZone
          campaignEndDate
          campaignEndTime
          publicCampaignAbout
          publicCampaignIntro
          campaignGoal
          perAmbassadorGoal
          totalAmbassadorsGoal
          perContactDonationGoal
          progressChartType
          ctaURL
          pageLayout
          primaryColor
          secondaryColor
          buttonBackgroundColor
          buttonTextColor
          customHeaderImageUploaded
          customLogoImageUploaded
          headerFont
          bodyFont
          ctaButtonText
          givingCircleBaseAmount
          givingCircleIncrements
          givingCircleAllowCustomAmounts
          ambassadorSpecificVideoUrlEnabled
          ambassadorCanUploadVideoUrl
          ambassadorSpecificCtaUrlEnabled
          ambassadorCanUploadCtaUrl
          crowbarVideoURL
          recruitmentForCampaignID
          classyCampaignID
          classyAutogenerateAmbassadorTeams
          classyDonationPageHostURL
          useClassyCtaURL
          useClassyFundraiserPage
          personalFundraisingCampaignID
          onDemandDiscoveryMeetingEnabled
          onDemandDiscoveryMeetingURL
          onDemandDiscoveryMeetingID
          onDemandDiscoveryMeetingInvitationCode
          CampaignConversationFlows {
            nextToken
          }
          defaultConversationFlowID
          defaultConversationFlow {
            id
            fundraisingCampaignID
            name
            description
            default
            active
            restricted
            useDefaultCta
            customCta
            allowAmbassadorSpecificCrowbarVideos
            generalCrowbarVideoURI
            deleted
            createdAt
            updatedAt
          }
          useConversationFlows
          campaignPageID
          ambassadorPageID
          donationPageID
          discoveryPageID
          projectID
          project {
            id
            status
            name
            description
            createdAt
            updatedAt
          }
          subscriptionDonationTiers {
            nextToken
          }
          useActionCardView
          createdAt
          updatedAt
          staffLead {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          owner
          recruitmentForCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          personalFundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          campaignPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          ambassadorPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          donationPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          discoveryPage {
            id
            name
            description
            type
            fundraisingCampaignID
            campaignDisplayConfigurationID
            pageHtml
            pageJSON
            pageCssJSON
            pageAssetsJSON
            createdAt
            updatedAt
            owner
          }
          onDemandDiscoveryMeeting {
            id
            title
            organizationID
            fundraisingCampaignID
            staffProfileID
            startTimestamp
            endTimestamp
            latentHosted
            invitationURL
            nylasEventID
            virtualMeetingURL
            createdAt
            updatedAt
            owner
          }
        }
        campaignPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        ambassadorPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        donationPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        discoveryPage {
          id
          name
          description
          type
          fundraisingCampaignID
          campaignDisplayConfigurationID
          pageHtml
          pageJSON
          pageCssJSON
          pageAssetsJSON
          createdAt
          updatedAt
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
          campaignDisplayConfiguration {
            id
            campaignPageID
            primaryColor
            secondaryColor
            gradientLeftColor
            gradientRightColor
            buttonBackgroundColor
            buttonTextColor
            headerFont
            bodyFont
            createdAt
            updatedAt
            owner
          }
        }
        onDemandDiscoveryMeeting {
          id
          title
          organizationID
          fundraisingCampaignID
          staffProfileID
          startTimestamp
          endTimestamp
          latentHosted
          invitationURL
          nylasEventID
          virtualMeetingURL
          createdAt
          updatedAt
          staffProfile {
            id
            authAccountID
            organizationID
            role
            name
            nylasAccountID
            nylasCalendarToken
            nylasPrimaryCalendarID
            createdAt
            updatedAt
            owner
          }
          organization {
            id
            name
            shortName
            description
            locationID
            website
            phoneNumber
            stripeConnectedAccountID
            stripeConnectedAccountStatus
            headerImageURI
            ambassadorTermOverrideSingular
            ambassadorTermOverridePlural
            streamJwt
            latentSubscription
            primaryColor
            secondaryColor
            designation
            detailsID
            createdAt
            updatedAt
            owner
          }
          fundraisingCampaign {
            id
            type
            organizationID
            staffLeadID
            campaignName
            introVideoURI
            textMessageTemplate
            initialMessageReminderTemplate
            phoneCallScriptTemplate
            followUpMessageTemplate
            followUpYesMessageTemplate
            followUpNoMessageTemplate
            followUpReminderMessageTemplate
            showVideo
            showText
            showCall
            showFollowUp
            active
            publicVideoID
            publicVideoProvider
            campaignStartDate
            campaignStartTime
            campaignTimeZone
            campaignEndDate
            campaignEndTime
            publicCampaignAbout
            publicCampaignIntro
            campaignGoal
            perAmbassadorGoal
            totalAmbassadorsGoal
            perContactDonationGoal
            progressChartType
            ctaURL
            pageLayout
            primaryColor
            secondaryColor
            buttonBackgroundColor
            buttonTextColor
            customHeaderImageUploaded
            customLogoImageUploaded
            headerFont
            bodyFont
            ctaButtonText
            givingCircleBaseAmount
            givingCircleIncrements
            givingCircleAllowCustomAmounts
            ambassadorSpecificVideoUrlEnabled
            ambassadorCanUploadVideoUrl
            ambassadorSpecificCtaUrlEnabled
            ambassadorCanUploadCtaUrl
            crowbarVideoURL
            recruitmentForCampaignID
            classyCampaignID
            classyAutogenerateAmbassadorTeams
            classyDonationPageHostURL
            useClassyCtaURL
            useClassyFundraiserPage
            personalFundraisingCampaignID
            onDemandDiscoveryMeetingEnabled
            onDemandDiscoveryMeetingURL
            onDemandDiscoveryMeetingID
            onDemandDiscoveryMeetingInvitationCode
            defaultConversationFlowID
            useConversationFlows
            campaignPageID
            ambassadorPageID
            donationPageID
            discoveryPageID
            projectID
            useActionCardView
            createdAt
            updatedAt
            owner
          }
          owner
        }
      }
      owner
    }
  }
`;
